export const FORM_DEFAULT = "default";
export const FORM_ON = "on";
export const FORM_NONE = "none";
export const COLOR_WHITE = "#ffffff";
export const COLOR_BLACK = "#000000";
export const COLOR_PURPLE = "#8900d5";
export const COLOR_TRANSPARENT = "rgba(0, 0, 0, 0)";

export const MARKERS_BORDER = {
  default: {
    path: '<path d="M0,0v14h14V0H0z M12,12H2V2h10V12z"/>',
    rotate: false,
  },
  flurry: {
    path: '<path d="M0.2,0.1L0.1,0.6l0.1,0.5L0.2,1.6L0.1,2.1l0.1,0.5L0,3.1l0,0.5L0,4l0.1,0.5l0,0.5l0.1,0.5L0.1,6l0,0.5l0,0.5 l0.2,0.5L0.1,8l0.1,0.5L0,8.9l0.2,0.5L0,9.9l0.2,0.5l-0.1,0.5l0,0.5L0,11.9l0.2,0.5l-0.1,0.5l0.1,0.5l0,0.4L0.6,14l0.5,0l0.5-0.1 l0.5,0.1l0.5,0.1L3.1,14l0.5-0.1l0.5-0.1l0.5,0L5,13.9l0.5-0.1l0.5,0l0.5,0L7,13.9L7.5,14L8,14l0.5-0.2L9,13.9L9.4,14l0.5-0.2 l0.5,0.2l0.5-0.1l0.5,0l0.5-0.1l0.5,0l0.5,0l0.5,0l0.5,0.1l-0.1-0.5l0.2-0.5l-0.1-0.5l-0.1-0.5l0.2-0.5l-0.2-0.5l0.1-0.5L14,9.9 l-0.2-0.5L13.9,9L14,8.5L14,8l-0.2-0.5l0-0.5l0.1-0.5L13.8,6l0-0.5L14,5l0-0.5l-0.1-0.5l0.1-0.5l-0.2-0.5l0.1-0.5l0-0.5l0-0.5 l-0.1-0.5L14,0.6l-0.2-0.4l-0.4,0l-0.5,0L12.4,0l-0.5,0.2l-0.5,0l-0.5-0.1l-0.5,0L10,0l-0.5,0L9,0L8.5,0.2L8,0.2L7.5,0.1L7,0.1 L6.5,0.2L6,0L5.5,0.2L5.1,0.2L4.6,0.1L4.1,0.1L3.6,0L3.1,0.1L2.6,0L2.1,0.1l-0.5,0l-0.5,0L0.6,0.2L0.2,0.1z M11.9,11.9l-0.5-0.1 L10.9,12l-0.5-0.1L10,11.9l-0.5,0.1L9,11.8l-0.5,0l-0.5,0l-0.5,0.1l-0.5,0L6.5,12L6,11.9l-0.5,0l-0.5,0L4.6,12l-0.5-0.2L3.6,12 l-0.5-0.1L2.6,12l-0.4-0.1L2,11.4l0.1-0.5l0-0.5l0.1-0.5L2,9.5L2.1,9L2,8.5L2,8l0.2-0.5l0-0.5L2,6.5L2.1,6l0.1-0.5L2.2,5L2.1,4.5 L2,4.1l0-0.5l0.2-0.5L2,2.6L2,2l0.5,0l0.5,0.1l0.5,0.1l0.5,0L4.5,2L5,2.1l0.5,0.1L6,2l0.5,0.2L7,2.1l0.5,0L8,2l0.5,0L9,2l0.5,0 l0.5,0.1L10.4,2l0.5,0.2L11.4,2L12,2l-0.1,0.6L12,3.1l-0.1,0.5L11.8,4L12,4.5L11.9,5l-0.1,0.5l0,0.5L12,6.5L12,7l-0.1,0.5L12,8 l0,0.5l-0.2,0.5l0,0.5l0.1,0.5l-0.1,0.5l0.2,0.5l-0.1,0.5L11.9,11.9z"/>',
    rotate: false,
  },
  sdoz: {
    path: '<path d="M0,0l0.9,13c0,0.6,0.5,1,1,1h12V2c0-0.6-0.4-1-1-1L0,0z M12,12H3.8c-0.5,0-1-0.4-1-1L2,2l9,0.7c0.5,0,1,0.5,1,1 V12z"/>',
    rotate: true,
  },
  drop_in: {
    path: '<path d="M0,0l0,7c0,3.9,3.1,7,7,7h0c3.9,0,7-3.1,7-7v0c0-3.9-3.1-7-7-7H0z M7,12L7,12c-2.8,0-5-2.2-5-5V2h5c2.8,0,5,2.2,5,5v0 C12,9.8,9.8,12,7,12z"/>',
    rotate: true,
  },
  drop: {
    path: '<path d="M0,7L0,7c0,3.9,3.1,7,7,7h7V7c0-3.9-3.1-7-7-7h0C3.1,0,0,3.1,0,7z M12,12H7c-2.8,0-5-2.2-5-5v0c0-2.8,2.2-5,5-5h0 c2.8,0,5,2.2,5,5V12z"/>',
    rotate: true,
  },
  dropeye: {
    path: '<path d="M0,0l0,7c0,3.9,3.1,7,7,7h7V7c0-3.9-3.1-7-7-7H0z M12,12H7c-2.8,0-5-2.2-5-5V2h5c2.8,0,5,2.2,5,5V12z"/>',
    rotate: true,
  },
  dropeyeleft: {
    path: '<path d="M0,0l0,7c0,3.9,3.1,7,7,7h7V7c0-3.9-3.1-7-7-7H0z M12,12H7c-2.8,0-5-2.2-5-5v0c0-2.8,2.2-5,5-5h0c2.8,0,5,2.2,5,5V12z"/>',
    rotate: true,
  },
  dropeyeleaf: {
    path: '<path d="M0,0l0,7c0,3.9,3.1,7,7,7h7V7c0-3.9-3.1-7-7-7H0z M7,12L7,12c-2.8,0-5-2.2-5-5v0c0-2.8,2.2-5,5-5h0c2.8,0,5,2.2,5,5v0 C12,9.8,9.8,12,7,12z"/>',
    rotate: true,
  },
  dropeyeright: {
    path: '<path d="M0,0l0,7c0,3.9,3.1,7,7,7h7V7c0-3.9-3.1-7-7-7H0z M7,12L7,12c-2.8,0-5-2.2-5-5V2h5c2.8,0,5,2.2,5,5v0C12,9.8,9.8,12,7,12z"/>',
    rotate: true,
  },
  squarecircle: {
    path: '<path d="M0,0l0,14h14V0H0z M7,12L7,12c-2.8,0-5-2.2-5-5v0c0-2.8,2.2-5,5-5h0c2.8,0,5,2.2,5,5v0C12,9.8,9.8,12,7,12z"/>',
    rotate: false,
  },
  circle: {
    path: '<path d="M0,7L0,7c0,3.9,3.1,7,7,7h0c3.9,0,7-3.1,7-7v0c0-3.9-3.1-7-7-7h0C3.1,0,0,3.1,0,7z M7,12L7,12c-2.8,0-5-2.2-5-5v0 c0-2.8,2.2-5,5-5h0c2.8,0,5,2.2,5,5v0C12,9.8,9.8,12,7,12z"/>',
    rotate: false,
  },
  rounded: {
    path: '<path d="M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"/>',
    rotate: false,
  },
  flower: {
    path: '<path d="M0,0v9.6C0,12,2,14,4.4,14h5.1C12,14,14,12,14,9.6V4.4C14,2,12,0,9.6,0H0z M9.2,12H4.8C3.3,12,2,10.7,2,9.2V2h7.2 C10.7,2,12,3.3,12,4.8v4.4C12,10.7,10.7,12,9.2,12z"/>',
    rotate: true,
  },
  flower_in: {
    path: '<path d="M14,14V4.4C14,2,12,0,9.6,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.4,14H14z M4.8,2h4.4C10.7,2,12,3.3,12,4.8V12H4.8 C3.3,12,2,10.7,2,9.2V4.8C2,3.3,3.3,2,4.8,2z"/>',
    rotate: true,
  },
  leaf: {
    path: '<path d="M0,0v9.6C0,12,2,14,4.4,14H14V4.4C14,2,12,0,9.6,0H0z M12,12H4.8C3.3,12,2,10.7,2,9.2V2h7.2C10.7,2,12,3.3,12,4.8V12z"/>',
    rotate: true,
  },
  "3-corners": {
    path: '<path d="M14,0H4.4C2,0,0,2,0,4.4V14h14V0z M2,12V4.8C2,3.3,3.3,2,4.8,2H12v10H2z"/>',
    rotate: true,
  },
  vortex: {
    path: `<path d="M13.8,1.1c-3.5,3.9-3.8-1.9-12.8-0.9c3.9,3.5-1.9,3.8-0.9,12.8c3.5-3.9,3.8,1.9,12.8,0.9C9.1,10.4,14.9,10.1,13.8,1.1z M9.4,13.2c-6.5-1.6-5.2-5.6-8.6-3.8c1.6-6.5,5.6-5.2,3.8-8.6c6.5,1.6,5.2,5.6,8.6,3.8C11.7,11.1,7.6,9.8,9.4,13.2z"/><path d="M5.8,4.6"/>`,
    rotate: false,
  },
  dots: {
    path: '<path d="M14,3.1c0-0.4-0.3-0.8-0.6-1c0.4-0.2,0.6-0.5,0.6-1C14,0.5,13.5,0,12.9,0c-0.4,0-0.8,0.3-1,0.6 c-0.2-0.4-0.5-0.6-1-0.6s-0.8,0.3-1,0.6C9.8,0.3,9.4,0,9,0C8.5,0,8.2,0.3,8,0.6C7.8,0.3,7.4,0,7,0S6.2,0.3,6,0.6C5.8,0.3,5.5,0,5,0 C4.6,0,4.2,0.3,4,0.6C3.9,0.3,3.5,0,3.1,0s-0.8,0.3-1,0.6C1.9,0.3,1.5,0,1.1,0C0.5,0,0,0.5,0,1.1c0,0.4,0.3,0.8,0.6,1 C0.3,2.2,0,2.6,0,3.1s0.3,0.8,0.6,1C0.3,4.2,0,4.6,0,5c0,0.4,0.3,0.8,0.6,1C0.3,6.2,0,6.6,0,7s0.3,0.8,0.6,1C0.3,8.2,0,8.5,0,9 c0,0.4,0.3,0.8,0.6,1c-0.4,0.2-0.6,0.5-0.6,1s0.3,0.8,0.6,1c-0.4,0.2-0.6,0.5-0.6,1C0,13.5,0.5,14,1.1,14c0.4,0,0.8-0.3,1-0.6 c0.2,0.4,0.5,0.6,1,0.6s0.8-0.3,1-0.6C4.2,13.7,4.6,14,5,14c0.4,0,0.8-0.3,1-0.6C6.2,13.7,6.6,14,7,14s0.8-0.3,1-0.6 C8.2,13.7,8.5,14,9,14c0.4,0,0.8-0.3,1-0.6c0.2,0.4,0.5,0.6,1,0.6s0.8-0.3,1-0.6c0.2,0.4,0.5,0.6,1,0.6c0.6,0,1.1-0.5,1.1-1.1 c0-0.4-0.3-0.8-0.6-1c0.4-0.2,0.6-0.5,0.6-1s-0.3-0.8-0.6-1C13.7,9.8,14,9.4,14,9c0-0.4-0.3-0.8-0.6-1C13.7,7.8,14,7.4,14,7 s-0.3-0.8-0.6-1C13.7,5.8,14,5.5,14,5c0-0.4-0.3-0.8-0.6-1C13.7,3.9,14,3.5,14,3.1z M11.9,12.5c-0.2-0.4-0.5-0.6-1-0.6 s-0.8,0.3-1,0.6c-0.2-0.4-0.5-0.6-1-0.6c-0.4,0-0.8,0.3-1,0.6c-0.2-0.4-0.5-0.6-1-0.6s-0.8,0.3-1,0.6c-0.2-0.4-0.5-0.6-1-0.6 c-0.4,0-0.8,0.3-1,0.6c-0.2-0.4-0.5-0.6-1-0.6s-0.8,0.3-1,0.6C2,12.2,1.8,12,1.5,11.9c0.4-0.2,0.6-0.5,0.6-1s-0.3-0.8-0.6-1 c0.4-0.2,0.6-0.5,0.6-1c0-0.4-0.3-0.8-0.6-1c0.4-0.2,0.6-0.5,0.6-1S1.9,6.2,1.5,6c0.4-0.2,0.6-0.5,0.6-1c0-0.4-0.3-0.8-0.6-1 c0.4-0.2,0.6-0.5,0.6-1s-0.3-0.8-0.6-1C1.8,2,2,1.8,2.1,1.5c0.2,0.4,0.5,0.6,1,0.6s0.8-0.3,1-0.6c0.2,0.4,0.5,0.6,1,0.6 c0.4,0,0.8-0.3,1-0.6c0.2,0.4,0.5,0.6,1,0.6s0.8-0.3,1-0.6c0.2,0.4,0.5,0.6,1,0.6c0.4,0,0.8-0.3,1-0.6c0.2,0.4,0.5,0.6,1,0.6 s0.8-0.3,1-0.6C12,1.8,12.2,2,12.5,2.1c-0.4,0.2-0.6,0.5-0.6,1s0.3,0.8,0.6,1c-0.4,0.2-0.6,0.5-0.6,1c0,0.4,0.3,0.8,0.6,1 c-0.4,0.2-0.6,0.5-0.6,1s0.3,0.8,0.6,1c-0.4,0.2-0.6,0.5-0.6,1c0,0.4,0.3,0.8,0.6,1c-0.4,0.2-0.6,0.5-0.6,1s0.3,0.8,0.6,1 C12.2,12,12,12.2,11.9,12.5z"/>',
    rotate: false,
  },
  bruised: {
    path: '<path d="M14,9.6V3c-1.7,0-3-1.3-3-3H4.4C2,0,0,2,0,4.4V11c1.7,0,3,1.3,3,3h6.6C12,14,14,12,14,9.6z M4.6,12C4.1,10.8,3.2,9.9,2,9.4 v-5C2,3.1,3.1,2,4.4,2h5c0.5,1.2,1.4,2.1,2.6,2.6v5c0,1.3-1.1,2.4-2.4,2.4H4.6z"/>',
    rotate: true,
  },
  canvas: {
    path: `<path class="st0" d="M13.8,1.8H14V0.2h-0.2V0h-1.6v0.2H12v0L11.7,0L11,0.4L10.3,0L9.7,0.4L9,0L8.3,0.4L7.7,0L7,0.4L6.3,0L5.7,0.4 L5,0L4.3,0.4L3.7,0L3,0.4L2.3,0L2,0.2v0H1.8V0H0.2v0.2H0v1.6h0.2V2h0L0,2.3L0.4,3L0,3.7l0.4,0.7L0,5l0.4,0.7L0,6.3L0.4,7L0,7.7 l0.4,0.7L0,9l0.4,0.7L0,10.3L0.4,11L0,11.7L0.2,12h0v0.2H0v1.6h0.2V14h1.6v-0.2H2v0L2.3,14L3,13.6L3.7,14l0.7-0.4L5,14l0.7-0.4 L6.3,14L7,13.6L7.7,14l0.7-0.4L9,14l0.7-0.4l0.7,0.4l0.7-0.4l0.7,0.4l0.3-0.2v0h0.2V14h1.6v-0.2H14v-1.6h-0.2V12h0l0.2-0.3L13.6,11 l0.4-0.7l-0.4-0.7L14,9l-0.4-0.7L14,7.7L13.6,7L14,6.3l-0.4-0.7L14,5l-0.4-0.7L14,3.7L13.6,3L14,2.3L13.8,2h0V1.8z M12.4,3L12,3.7 l0.4,0.7L12,5l0.4,0.7L12,6.3L12.4,7L12,7.7l0.4,0.7L12,9l0.4,0.7L12,10.3l0.4,0.7L12,11.7l0.2,0.3h0v0.2H12v0L11.7,12L11,12.4 L10.3,12l-0.7,0.4L9,12l-0.7,0.4L7.7,12L7,12.4L6.3,12l-0.7,0.4L5,12l-0.7,0.4L3.7,12L3,12.4L2.3,12L2,12.2v0H1.8V12h0L2,11.7 L1.6,11L2,10.3L1.6,9.7L2,9L1.6,8.3L2,7.7L1.6,7L2,6.3L1.6,5.7L2,5L1.6,4.3L2,3.7L1.6,3L2,2.3L1.8,2h0V1.8H2v0L2.3,2L3,1.6L3.7,2 l0.7-0.4L5,2l0.7-0.4L6.3,2L7,1.6L7.7,2l0.7-0.4L9,2l0.7-0.4L10.3,2L11,1.6L11.7,2L12,1.8v0h0.2V2h0L12,2.3L12.4,3z"/>`,
    rotate: true,
  },
};

export const MARKERS_OUTER = {
  default: {
    path: '<rect width="6" height="6"/>',
    rotate: false,
    preview:
      '<path d="M5,1h1l0-1L4,0v1H3V0L0,0v0v0v2h1V1h0h1h1v1v0v0l0,0H2v1H1H0h0v3h0v0h2v0H1l0-2h1l0,1h1v1h3v0H5v0V5h1V4H5v1H3 l0-2l1,0v1h1V3h1V2H5V1z M5,3H4V2h1V3z"/>',
    marker: true,
  },
  flurry: {
    path: '<polygon points="5.9,5.9 5.6,5.9 5.3,6 5,5.7 4.7,5.8 4.4,5.8 4.1,5.8 3.9,5.7 3.6,5.7 3.3,5.8 3,5.9 2.7,5.8 2.4,5.8 2.1,5.8 1.9,5.7 1.6,5.7 1.3,5.7 1,5.8 0.7,5.8 0.4,5.8 0.1,5.9 0,5.5 0.1,5.3 0,5 0.3,4.7 0.3,4.4 0.2,4.1 0.2,3.8 0.1,3.5 0.3,3.3 0.1,3 0.1,2.7 0.2,2.4 0.1,2.1 0.1,1.8 0.1,1.5 0.2,1.3 0.3,1 0,0.7 0,0.4 0.3,0.2 0.4,0.1 0.7,0.1 1,0.2 1.3,0.1 1.6,0.3 1.9,0.1 2.1,0.1 2.4,0.2 2.7,0.1 3,0.3 3.3,0.2 3.6,0.2 3.8,0.2 4.1,0.1 4.4,0.3 4.7,0.1 5,0.2 5.3,0.1 5.6,0 5.9,0 5.8,0.4 6,0.7 6,1 5.9,1.2 5.7,1.5 5.7,1.8 5.9,2.1 5.7,2.4 5.8,2.7 6,3 5.9,3.3 5.8,3.5 5.8,3.8 5.8,4.1 6,4.4 5.8,4.7 5.7,5 5.7,5.3 5.8,5.5"/>',
    rotate: false,
    marker: true,
  },
  sdoz: {
    path: '<polygon points="6,6 0.5,6 0,0 6,0.5"/>',
    rotate: true,
    marker: true,
  },
  drop_in: {
    path: '<path d="M3,6L3,6C1.3,6,0,4.7,0,3l0-3l3,0c1.7,0,3,1.3,3,3v0C6,4.7,4.7,6,3,6z"/>',
    rotate: true,
    marker: true,
  },
  drop: {
    path: '<path d="M6,6H3C1.3,6,0,4.7,0,3v0c0-1.7,1.3-3,3-3h0c1.7,0,3,1.3,3,3V6z"/>',
    rotate: true,
    marker: true,
  },
  dropeye: {
    path: '<path d="M6,6H3C1.3,6,0,4.7,0,3l0-3l3,0c1.7,0,3,1.3,3,3V6z"/>',
    rotate: true,
    marker: true,
  },
  circle: {
    path: '<circle cx="3" cy="3" r="3"/>',
    rotate: false,
    preview: `<circle cx="0.5" cy="0.5" r="0.5"/> <circle cx="1.5" cy="0.5" r="0.5"/> <circle cx="3.5" cy="0.5" r="0.5"/> <circle cx="4.5" cy="0.5" r="0.5"/> <circle cx="0.5" cy="1.5" r="0.5"/> <circle cx="4.5" cy="1.5" r="0.5"/> <circle cx="5.5" cy="1.5" r="0.5"/> <circle cx="0.5" cy="2.5" r="0.5"/> <circle cx="1.5" cy="2.5" r="0.5"/> <circle cx="0.5" cy="3.5" r="0.5"/> <circle cx="1.5" cy="3.5" r="0.5"/> <circle cx="4.5" cy="3.5" r="0.5"/> <circle cx="5.5" cy="3.5" r="0.5"/> <circle cx="2.5" cy="4.5" r="0.5"/> <circle cx="1.5" cy="5.5" r="0.5"/> <circle cx="3.5" cy="5.5" r="0.5"/> <circle cx="5.5" cy="5.5" r="0.5"/>`,
    marker: true,
  },
  dot: {
    path: '<circle cx="3" cy="3" r="2"/>',
    rotate: false,
    preview: `<circle cx="0.5" cy="0.5" r="0.3"/> <circle cx="1.5" cy="0.5" r="0.3"/> <circle cx="3.5" cy="0.5" r="0.3"/> <circle cx="4.5" cy="0.5" r="0.3"/> <circle cx="0.5" cy="1.5" r="0.3"/> <circle cx="4.5" cy="1.5" r="0.3"/> <circle cx="5.5" cy="1.5" r="0.3"/> <circle cx="0.5" cy="2.5" r="0.3"/> <circle cx="1.5" cy="2.5" r="0.3"/> <circle cx="0.5" cy="3.5" r="0.3"/> <circle cx="1.5" cy="3.5" r="0.3"/> <circle cx="4.5" cy="3.5" r="0.3"/> <circle cx="5.5" cy="3.5" r="0.3"/> <circle cx="2.5" cy="4.5" r="0.3"/> <circle cx="1.5" cy="5.5" r="0.3"/> <circle cx="3.5" cy="5.5" r="0.3"/> <circle cx="5.5" cy="5.5" r="0.3"/>`,
    marker: false,
  },
  rounded: {
    path: '<path d="M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"/>',
    rotate: false,
    marker: true,
  },
  sun: {
    path: '<polygon points="3,0 3.4,0.7 4,0.2 4.1,0.9 4.9,0.7 4.8,1.5 5.6,1.5 5.2,2.2 5.9,2.5 5.3,3 5.9,3.5 5.2,3.8 5.6,4.5 4.8,4.5 4.9,5.3 4.1,5.1 4,5.8 3.4,5.3 3,6 2.5,5.3 1.9,5.8 1.8,5.1 1,5.3 1.1,4.5 0.4,4.5 0.7,3.8 0,3.5 0.6,3 0,2.5 0.7,2.2 0.4,1.5 1.1,1.5 1,0.7 1.8,0.9 1.9,0.2 2.5,0.7"/>',
    rotate: false,
    marker: true,
  },
  star: {
    path: '<path d="M3.2,0.3l0.6,1.3C4,1.8,4.1,1.9,4.3,1.9l1.4,0.2c0.2,0,0.3,0.3,0.2,0.5l-1,1C4.7,3.7,4.7,3.9,4.7,4.1L5,5.5 c0,0.2-0.2,0.4-0.4,0.3L3.3,5.2c-0.2-0.1-0.4-0.1-0.6,0L1.4,5.8C1.2,5.9,1,5.8,1,5.5l0.2-1.4c0-0.2,0-0.4-0.2-0.5l-1-1 C-0.1,2.4,0,2.2,0.2,2.1l1.4-0.2c0.2,0,0.4-0.2,0.5-0.3l0.6-1.3C2.9,0.1,3.1,0.1,3.2,0.3z"/>',
    rotate: false,
    preview: `<polygon points="0.5,0.8 0.2,1 0.2,0.6 0,0.4 0.3,0.3 0.5,0 0.7,0.3 1,0.4 0.7,0.6 0.8,1"/> <polygon points="2.5,0.8 2.2,1 2.2,0.6 2,0.4 2.3,0.3 2.5,0 2.7,0.3 3,0.4 2.7,0.6 2.8,1"/> <polygon points="4.5,0.8 4.2,1 4.3,0.6 4,0.4 4.3,0.3 4.5,0 4.7,0.3 5,0.4 4.8,0.6 4.8,1"/> <polygon points="5.5,0.8 5.2,1 5.3,0.6 5,0.4 5.3,0.3 5.5,0 5.7,0.3 6,0.4 5.8,0.6 5.8,1"/> <polygon points="3.5,1.8 3.2,2 3.2,1.6 3,1.4 3.3,1.3 3.5,1 3.7,1.3 4,1.4 3.7,1.6 3.8,2"/> <polygon points="4.5,1.8 4.2,2 4.2,1.6 4,1.4 4.3,1.3 4.5,1 4.7,1.3 5,1.4 4.7,1.6 4.8,2"/> <polygon points="2.5,2.8 2.2,3 2.2,2.6 2,2.4 2.3,2.3 2.5,2 2.7,2.3 3,2.4 2.7,2.6 2.8,3"/> <polygon points="3.5,2.8 3.2,3 3.2,2.6 3,2.4 3.3,2.3 3.5,2 3.7,2.3 4,2.4 3.7,2.6 3.8,3"/> <polygon points="0.5,3.8 0.2,4 0.2,3.6 0,3.4 0.3,3.3 0.5,3 0.7,3.3 1,3.4 0.7,3.6 0.8,4"/> <polygon points="1.5,3.8 1.2,4 1.2,3.6 1,3.4 1.3,3.3 1.5,3 1.7,3.3 2,3.4 1.7,3.6 1.8,4"/> <polygon points="2.5,5.8 2.2,6 2.2,5.6 2,5.4 2.3,5.3 2.5,5 2.7,5.3 3,5.4 2.8,5.6 2.8,6"/> <polygon points="3.5,5.8 3.2,6 3.2,5.6 3,5.4 3.3,5.3 3.5,5 3.7,5.3 4,5.4 3.8,5.6 3.8,6"/> <polygon points="0.5,1.8 0.2,2 0.2,1.6 0,1.4 0.3,1.3 0.5,1 0.7,1.3 1,1.4 0.7,1.6 0.8,2"/> <polygon points="4.5,3.8 4.2,4 4.3,3.6 4,3.4 4.3,3.3 4.5,3 4.7,3.3 5,3.4 4.8,3.6 4.8,4"/> <polygon points="5.5,4.8 5.2,5 5.3,4.6 5,4.4 5.3,4.3 5.5,4 5.7,4.3 6,4.4 5.8,4.6 5.8,5"/> <polygon points="0.5,5.8 0.2,6 0.2,5.6 0,5.4 0.3,5.3 0.5,5 0.7,5.3 1,5.4 0.7,5.6 0.8,6"/>`,
    marker: true,
  },
  diamond: {
    path: '<rect x="0.9" y="0.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.2426 3)" width="4.2" height="4.2"/>',
    rotate: false,
    preview: `<rect x="0.1" y="0.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -0.2075 0.4992)" width="0.7" height="0.7"/> <rect x="0.1" y="1.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -0.9146 0.7923)" width="0.7" height="0.7"/> <rect x="2.1" y="0.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 0.3783 1.9134)" width="0.7" height="0.7"/> <rect x="4.1" y="0.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 0.9641 3.3276)" width="0.7" height="0.7"/> <rect x="5.1" y="0.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 1.257 4.0347)" width="0.7" height="0.7"/> <rect x="4.1" y="1.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 0.257 3.6205)" width="0.7" height="0.7"/> <rect x="3.1" y="1.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.593460e-02 2.9134)" width="0.7" height="0.7"/> <rect x="3.1" y="2.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -0.743 3.2063)" width="0.7" height="0.7"/> <rect x="2.1" y="2.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.0359 2.4992)" width="0.7" height="0.7"/> <rect x="1.1" y="3.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.0359 2.0849)" width="0.7" height="0.7"/> <rect x="0.1" y="3.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.3287 1.3777)" width="0.7" height="0.7"/> <rect x="0.1" y="5.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.7428 1.9634)" width="0.7" height="0.7"/> <rect x="2.1" y="5.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.1573 3.3778)" width="0.7" height="0.7"/> <rect x="3.1" y="5.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.8644 4.0849)" width="0.7" height="0.7"/> <rect x="5.1" y="4.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.5715 5.2063)" width="0.7" height="0.7"/> <rect x="4.1" y="3.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.1573 4.2063)" width="0.7" height="0.7"/>`,
    marker: true,
  },
  sparkle: {
    path: '<path d="M3,0L3,0c0,1.7-1.3,3-3,3h0h0c1.7,0,3,1.3,3,3v0v0c0-1.7,1.3-3,3-3h0h0C4.3,3,3,1.7,3,0L3,0z"/>',
    rotate: false,
    preview: `<path d="M0.4,0.9L0.4,0.9L0.4,0.9h0.1c0-0.2,0.2-0.3,0.4-0.4l0.1,0l0.1,0c0.2,0,0.3,0.2,0.4,0.4v0.1c0,0.2-0.2,0.3-0.4,0.4L1,1.5 v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4v0.1c0,0.2-0.2,0.3-0.4,0.4L1,2.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1 c0-0.2,0.2-0.3,0.4-0.4l0.1,0V2.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4V1.9c0-0.2,0.2-0.3,0.4-0.4l0.1,0V1.5l-0.1,0 c-0.2,0-0.3-0.2-0.4-0.4V0.9c0-0.2,0.2-0.3,0.4-0.4l0.1,0V0.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H1.5l0,0.1 c0,0.2-0.2,0.3-0.4,0.4L1,0.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H0.5l0,0.1c0,0.2-0.2,0.3-0.4,0.4L0,0.5v0.1l0.1,0 C0.3,0.6,0.4,0.7,0.4,0.9z"/> <path d="M3.6,4.1L3.6,4.1L3.6,4.1H3.4c0,0.2-0.2,0.3-0.4,0.4H2.9c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H2.5l0,0.1c0,0.2-0.2,0.3-0.4,0.4 L2,4.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4v0.1c0,0.2-0.2,0.3-0.4,0.4H1.9c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H1.5l0,0.1 c0,0.2-0.2,0.3-0.4,0.4H0.9c-0.2,0-0.3-0.2-0.4-0.4V4.9c0-0.2,0.2-0.3,0.4-0.4l0.1,0V4.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4V3.9 c0-0.2,0.2-0.3,0.4-0.4l0.1,0V3.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H0.5l0,0.1c0,0.2-0.2,0.3-0.4,0.4L0,3.5v0.1l0.1,0 c0.2,0,0.3,0.2,0.4,0.4v0.1c0,0.2-0.2,0.3-0.4,0.4L0,4.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4v0.1c0,0.2-0.2,0.3-0.4,0.4L0,5.5v0.1 l0.1,0c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1c0-0.2,0.2-0.3,0.4-0.4h0.1c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1 c0-0.2,0.2-0.3,0.4-0.4h0.1c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1c0-0.2,0.2-0.3,0.4-0.4h0.1c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1 l0-0.1c0-0.2,0.2-0.3,0.4-0.4l0.1,0V5.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4V4.9c0-0.2,0.2-0.3,0.4-0.4l0.1,0V4.5l-0.1,0 C3.7,4.4,3.6,4.3,3.6,4.1z M3.4,5.1c0,0.2-0.2,0.3-0.4,0.4H2.9c-0.2,0-0.3-0.2-0.4-0.4V4.9c0-0.2,0.2-0.3,0.4-0.4h0.1 c0.2,0,0.3,0.2,0.4,0.4V5.1z"/> <path d="M5.6,4.1L5.6,4.1L5.6,4.1H5.4c0,0.2-0.2,0.3-0.4,0.4L5,4.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1 c0-0.2,0.2-0.3,0.4-0.4l0.1,0V4.5l-0.1,0C5.7,4.4,5.6,4.3,5.6,4.1z"/> <path d="M5.6,2.1L5.6,2.1L5.6,2.1H5.4c0,0.2-0.2,0.3-0.4,0.4H4.9c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H4.5l0,0.1c0,0.2-0.2,0.3-0.4,0.4 H3.9c-0.2,0-0.3-0.2-0.4-0.4V1.9c0-0.2,0.2-0.3,0.4-0.4l0.1,0V1.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4V0.9c0-0.2,0.2-0.3,0.4-0.4l0.1,0 V0.5l-0.1,0c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H3.5l0,0.1c0,0.2-0.2,0.3-0.4,0.4L3,0.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4v0.1 c0,0.2-0.2,0.3-0.4,0.4L3,1.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4v0.1c0,0.2-0.2,0.3-0.4,0.4L3,2.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4 l0,0.1h0.1l0-0.1c0-0.2,0.2-0.3,0.4-0.4h0.1c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1c0-0.2,0.2-0.3,0.4-0.4h0.1 c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1l0-0.1c0-0.2,0.2-0.3,0.4-0.4l0.1,0V2.5l-0.1,0C5.7,2.4,5.6,2.3,5.6,2.1z"/> <path d="M5.9,0.4c-0.2,0-0.3-0.2-0.4-0.4l0-0.1H5.5l0,0.1c0,0.2-0.2,0.3-0.4,0.4L5,0.5v0.1l0.1,0c0.2,0,0.3,0.2,0.4,0.4l0,0.1h0.1 l0-0.1c0-0.2,0.2-0.3,0.4-0.4V0.4L5.9,0.4L5.9,0.4z"/>`,
  },
  danger: {
    path: '<polygon points="3,5.1 3.9,6 6,6 6,3.9 5.1,3 6,2.1 6,0 3.9,0 3,0.9 2.1,0 0,0 0,2.1 0.9,3 0,3.9 0,6 2.1,6"/>',
    rotate: false,
    preview: `<polygon points="2.9,0.5 3,0.4 3,0 2.6,0 2.5,0.1 2.4,0 2,0 2,0.4 2.1,0.5 2,0.6 2,1 2.4,1 2.5,0.9 2.6,1 3,1 3,0.6"/> <path d="M6,0H5.6L5.5,0.1L5.4,0H5H4.6L4.5,0.1L4.4,0H4v0.4l0.1,0.1L4,0.6V1H3.6L3.5,1.1L3.4,1H3v0.4l0.1,0.1L3,1.6V2 h0.4l0.1-0.1L3.6,2H4h0.4l0.1-0.1L4.6,2H5V1.6L4.9,1.5L5,1.4V1h0.4l0.1-0.1L5.6,1H6V0.6L5.9,0.5L6,0.4V0z M4,1.6L3.9,1.5L4,1.4 l0.1,0.1L4,1.6z M4.5,1.1L4.4,1l0.1-0.1L4.6,1L4.5,1.1z M5,0.6L4.9,0.5L5,0.4l0.1,0.1L5,0.6z"/> <polygon points="2.5,2.1 2.4,2 2,2 2,2.4 2.1,2.5 2,2.6 2,3 2.4,3 2.5,2.9 2.6,3 3,3 3,2.6 2.9,2.5 3,2.4 3,2 2.6,2"/> <path d="M0.5,1.9L0.6,2H1V1.6L0.9,1.5L1,1.4V1V0.6L0.9,0.5L1,0.4V0H0.6L0.5,0.1L0.4,0H0v0.4l0.1,0.1L0,0.6V1v0.4 l0.1,0.1L0,1.6V2h0.4L0.5,1.9z M0.5,0.9L0.6,1L0.5,1.1L0.4,1L0.5,0.9z"/> <path d="M1.5,3.1L1.4,3H1H0.6L0.5,3.1L0.4,3H0v0.4l0.1,0.1L0,3.6V4h0.4l0.1-0.1L0.6,4H1h0.4l0.1-0.1L1.6,4H2V3.6 L1.9,3.5L2,3.4V3H1.6L1.5,3.1z M1,3.6L0.9,3.5L1,3.4l0.1,0.1L1,3.6z"/> <polygon points="0.5,5.1 0.4,5 0,5 0,5.4 0.1,5.5 0,5.6 0,6 0.4,6 0.5,5.9 0.6,6 1,6 1,5.6 0.9,5.5 1,5.4 1,5 0.6,5"/> <path d="M3.5,5.1L3.4,5H3H2.6L2.5,5.1L2.4,5H2v0.4l0.1,0.1L2,5.6V6h0.4l0.1-0.1L2.6,6H3h0.4l0.1-0.1L3.6,6H4V5.6 L3.9,5.5L4,5.4V5H3.6L3.5,5.1z M3,5.6L2.9,5.5L3,5.4l0.1,0.1L3,5.6z"/> <polygon points="4.9,3.5 5,3.4 5,3 4.6,3 4.5,3.1 4.4,3 4,3 4,3.4 4.1,3.5 4,3.6 4,4 4.4,4 4.5,3.9 4.6,4 5,4 5,3.6"/> <polygon points="5.5,4.1 5.4,4 5,4 5,4.4 5.1,4.5 5,4.6 5,5 5.4,5 5.5,4.9 5.6,5 6,5 6,4.6 5.9,4.5 6,4.4 6,4 5.6,4"/>`,
    marker: true,
  },
  cross: {
    path: '<polygon points="6,1.5 4.5,1.5 4.5,0 1.5,0 1.5,1.5 0,1.5 0,4.5 1.5,4.5 1.5,6 4.5,6 4.5,4.5 6,4.5"/>',
    rotate: false,
    preview: `polygon points="0.3,2 0.7,2 0.7,1.7 1,1.7 1,1.3 0.7,1.3 0.7,1 0.7,0.7 1,0.7 1,0.3 0.7,0.3 0.7,0 0.3,0 0.3,0.3 0,0.3 0,0.7 0.3,0.7 0.3,1 0.3,1.3 0,1.3 0,1.7 0.3,1.7 "/> <polygon points="2.3,1 2.7,1 2.7,0.7 3,0.7 3,0.3 2.7,0.3 2.7,0 2.3,0 2.3,0.3 2,0.3 2,0.7 2.3,0.7 "/> <polygon points="5.7,0.3 5.7,0 5.3,0 5.3,0.3 5,0.3 4.7,0.3 4.7,0 4.3,0 4.3,0.3 4,0.3 4,0.7 4.3,0.7 4.3,1 4.3,1.3 4,1.3 3.7,1.3 3.7,1 3.3,1 3.3,1.3 3,1.3 3,1.7 3.3,1.7 3.3,2 3.7,2 3.7,1.7 4,1.7 4,1.7 4.3,1.7 4.3,2 4.7,2 4.7,1.7 5,1.7 5,1.3 4.7,1.3 4.7,1 4.7,0.7 5,0.7 5,0.7 5.3,0.7 5.3,1 5.7,1 5.7,0.7 6,0.7 6,0.3 "/> <polygon points="2.3,3 2.7,3 2.7,2.7 3,2.7 3,2.3 2.7,2.3 2.7,2 2.3,2 2.3,2.3 2,2.3 2,2.7 2.3,2.7 "/> <polygon points="1.7,3 1.3,3 1.3,3.3 1,3.3 0.7,3.3 0.7,3 0.3,3 0.3,3.3 0,3.3 0,3.7 0.3,3.7 0.3,4 0.7,4 0.7,3.7 1,3.7 1,3.7 1.3,3.7 1.3,4 1.7,4 1.7,3.7 2,3.7 2,3.3 1.7,3.3 "/> <polygon points="4.7,3 4.3,3 4.3,3.3 4,3.3 4,3.7 4.3,3.7 4.3,4 4.7,4 4.7,3.7 5,3.7 5,3.3 4.7,3.3 "/> <polygon points="5.7,4 5.3,4 5.3,4.3 5,4.3 5,4.7 5.3,4.7 5.3,5 5.7,5 5.7,4.7 6,4.7 6,4.3 5.7,4.3 "/> <polygon points="3.7,5 3.3,5 3.3,5.3 3,5.3 2.7,5.3 2.7,5 2.3,5 2.3,5.3 2,5.3 2,5.7 2.3,5.7 2.3,6 2.7,6 2.7,5.7 3,5.7 3,5.7 3.3,5.7 3.3,6 3.7,6 3.7,5.7 4,5.7 4,5.3 3.7,5.3 "/> <polygon points="0.7,5 0.3,5 0.3,5.3 0,5.3 0,5.7 0.3,5.7 0.3,6 0.7,6 0.7,5.7 1,5.7 1,5.3 0.7,5.3 "/>`,
    marker: true,
  },
  plus: {
    path: '<path d="M4.5,1.5L4.5,1.5L4.5,1.5C4.5,0.7,3.8,0,3,0h0C2.2,0,1.5,0.7,1.5,1.5v0h0C0.7,1.5,0,2.2,0,3v0 c0,0.8,0.7,1.5,1.5,1.5h0v0C1.5,5.3,2.2,6,3,6h0c0.8,0,1.5-0.7,1.5-1.5v0h0C5.3,4.5,6,3.8,6,3v0C6,2.2,5.3,1.5,4.5,1.5z"/>',
    rotate: false,
    preview: `<path d="M0.7,0.8L0.7,0.8L0.7,0.8c0.1-0.1,0.2-0.1,0.2-0.1C1,0.6,1,0.6,1,0.5c0-0.1-0.1-0.2-0.2-0.2H0.7V0.2 C0.7,0.1,0.6,0,0.5,0S0.3,0.1,0.3,0.2v0.1H0.2C0.1,0.3,0,0.4,0,0.5s0.1,0.2,0.2,0.2h0.1v0.1C0.3,0.9,0.4,1,0.5,1 c0.1,0,0.1,0,0.2-0.1S0.7,0.8,0.7,0.8z"/> <path d="M2.2,0.7L2.2,0.7L2.2,0.7C2.3,0.9,2.4,1,2.5,1c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V0.7h0.1 c0.1,0,0.1,0,0.2-0.1C3,0.6,3,0.6,3,0.5c0-0.1-0.1-0.2-0.2-0.2H2.7V0.2C2.7,0.1,2.6,0,2.5,0S2.3,0.1,2.3,0.2v0.1H2.2 C2.1,0.3,2,0.4,2,0.5S2.1,0.7,2.2,0.7z"/> <path d="M4.7,0.8L4.7,0.8L4.7,0.8c0.1-0.1,0.2-0.1,0.2-0.1C5,0.6,5,0.6,5,0.5c0-0.1-0.1-0.2-0.2-0.2H4.7V0.2 C4.7,0.1,4.6,0,4.5,0S4.3,0.1,4.3,0.2v0.1H4.2C4.1,0.3,4,0.4,4,0.5s0.1,0.2,0.2,0.2h0.1v0.1C4.3,0.9,4.4,1,4.5,1 c0.1,0,0.1,0,0.2-0.1S4.7,0.8,4.7,0.8z"/> <path d="M5.2,0.7L5.2,0.7L5.2,0.7C5.3,0.9,5.4,1,5.5,1c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V0.7h0.1 c0.1,0,0.1,0,0.2-0.1C6,0.6,6,0.6,6,0.5c0-0.1-0.1-0.2-0.2-0.2H5.7V0.2C5.7,0.1,5.6,0,5.5,0S5.3,0.1,5.3,0.2v0.1H5.2 C5.1,0.3,5,0.4,5,0.5S5.1,0.7,5.2,0.7z"/> <path d="M4.2,1.7L4.2,1.7L4.2,1.7C4.3,1.9,4.4,2,4.5,2c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V1.7h0.1 c0.1,0,0.1,0,0.2-0.1C5,1.6,5,1.6,5,1.5c0-0.1-0.1-0.2-0.2-0.2H4.7V1.2C4.7,1.1,4.6,1,4.5,1S4.3,1.1,4.3,1.2v0.1H4.2 C4.1,1.3,4,1.4,4,1.5S4.1,1.7,4.2,1.7z"/> <path d="M3.7,1.8L3.7,1.8L3.7,1.8c0.1-0.1,0.2-0.1,0.2-0.1C4,1.6,4,1.6,4,1.5c0-0.1-0.1-0.2-0.2-0.2H3.7V1.2 C3.7,1.1,3.6,1,3.5,1S3.3,1.1,3.3,1.2v0.1H3.2C3.1,1.3,3,1.4,3,1.5s0.1,0.2,0.2,0.2h0.1v0.1C3.3,1.9,3.4,2,3.5,2 c0.1,0,0.1,0,0.2-0.1S3.7,1.8,3.7,1.8z"/> <path d="M3.2,2.7L3.2,2.7L3.2,2.7C3.3,2.9,3.4,3,3.5,3c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V2.7h0.1 c0.1,0,0.1,0,0.2-0.1C4,2.6,4,2.6,4,2.5c0-0.1-0.1-0.2-0.2-0.2H3.7V2.2C3.7,2.1,3.6,2,3.5,2S3.3,2.1,3.3,2.2v0.1H3.2 C3.1,2.3,3,2.4,3,2.5S3.1,2.7,3.2,2.7z"/> <path d="M2.2,2.7L2.2,2.7L2.2,2.7C2.3,2.9,2.4,3,2.5,3c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V2.7h0.1 c0.1,0,0.1,0,0.2-0.1C3,2.6,3,2.6,3,2.5c0-0.1-0.1-0.2-0.2-0.2H2.7V2.2C2.7,2.1,2.6,2,2.5,2S2.3,2.1,2.3,2.2v0.1H2.2 C2.1,2.3,2,2.4,2,2.5S2.1,2.7,2.2,2.7z"/> <path d="M0.3,1.2L0.3,1.2L0.3,1.2C0.1,1.3,0,1.4,0,1.5s0.1,0.2,0.2,0.2h0.1v0.1C0.3,1.9,0.4,2,0.5,2 c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V1.7h0.1c0.1,0,0.1,0,0.2-0.1C1,1.6,1,1.6,1,1.5c0-0.1-0.1-0.2-0.2-0.2H0.7V1.2 C0.7,1.1,0.6,1,0.5,1S0.3,1.1,0.3,1.2z"/> <path d="M0.8,3.3L0.8,3.3L0.8,3.3C0.7,3.1,0.6,3,0.5,3S0.3,3.1,0.3,3.2v0.1H0.2C0.1,3.3,0,3.4,0,3.5s0.1,0.2,0.2,0.2 h0.1v0.1C0.3,3.9,0.4,4,0.5,4c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V3.7h0.1c0.1,0,0.1,0,0.2-0.1C1,3.6,1,3.6,1,3.5 C1,3.4,0.9,3.3,0.8,3.3z"/> <path d="M1.8,3.3L1.8,3.3L1.8,3.3C1.7,3.1,1.6,3,1.5,3S1.3,3.1,1.3,3.2v0.1H1.2C1.1,3.3,1,3.4,1,3.5s0.1,0.2,0.2,0.2 h0.1v0.1C1.3,3.9,1.4,4,1.5,4c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V3.7h0.1c0.1,0,0.1,0,0.2-0.1C2,3.6,2,3.6,2,3.5 C2,3.4,1.9,3.3,1.8,3.3z"/> <path d="M4.8,3.3L4.8,3.3L4.8,3.3C4.7,3.1,4.6,3,4.5,3S4.3,3.1,4.3,3.2v0.1H4.2C4.1,3.3,4,3.4,4,3.5s0.1,0.2,0.2,0.2 h0.1v0.1C4.3,3.9,4.4,4,4.5,4c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V3.7h0.1c0.1,0,0.1,0,0.2-0.1C5,3.6,5,3.6,5,3.5 C5,3.4,4.9,3.3,4.8,3.3z"/> <path d="M5.8,4.3L5.8,4.3L5.8,4.3C5.7,4.1,5.6,4,5.5,4S5.3,4.1,5.3,4.2v0.1H5.2C5.1,4.3,5,4.4,5,4.5s0.1,0.2,0.2,0.2 h0.1v0.1C5.3,4.9,5.4,5,5.5,5c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V4.7h0.1c0.1,0,0.1,0,0.2-0.1C6,4.6,6,4.6,6,4.5 C6,4.4,5.9,4.3,5.8,4.3z"/> <path d="M3.8,5.3L3.8,5.3L3.8,5.3C3.7,5.1,3.6,5,3.5,5S3.3,5.1,3.3,5.2v0.1H3.2C3.1,5.3,3,5.4,3,5.5s0.1,0.2,0.2,0.2 h0.1v0.1C3.3,5.9,3.4,6,3.5,6c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V5.7h0.1c0.1,0,0.1,0,0.2-0.1C4,5.6,4,5.6,4,5.5 C4,5.4,3.9,5.3,3.8,5.3z"/> <path d="M2.8,5.3L2.8,5.3L2.8,5.3C2.7,5.1,2.6,5,2.5,5S2.3,5.1,2.3,5.2v0.1H2.2C2.1,5.3,2,5.4,2,5.5s0.1,0.2,0.2,0.2 h0.1v0.1C2.3,5.9,2.4,6,2.5,6c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V5.7h0.1c0.1,0,0.1,0,0.2-0.1C3,5.6,3,5.6,3,5.5 C3,5.4,2.9,5.3,2.8,5.3z"/> <path d="M0.8,5.3L0.8,5.3L0.8,5.3C0.7,5.1,0.6,5,0.5,5S0.3,5.1,0.3,5.2v0.1H0.2C0.1,5.3,0,5.4,0,5.5s0.1,0.2,0.2,0.2 h0.1v0.1C0.3,5.9,0.4,6,0.5,6c0.1,0,0.1,0,0.2-0.1s0.1-0.1,0.1-0.2V5.7h0.1c0.1,0,0.1,0,0.2-0.1C1,5.6,1,5.6,1,5.5 C1,5.4,0.9,5.3,0.8,5.3z"/>`, marker: true,
  },
  x: {
    path: '<path d="M3,5.1l0.4,0.4C3.7,5.8,4.1,6,4.5,6h0C5.3,6,6,5.3,6,4.5v0c0-0.4-0.2-0.8-0.4-1.1L5.1,3l0.4-0.4 C5.8,2.3,6,1.9,6,1.5v0C6,0.7,5.3,0,4.5,0h0C4.1,0,3.7,0.2,3.4,0.4L3,0.9L2.6,0.4C2.3,0.2,1.9,0,1.5,0h0C0.7,0,0,0.7,0,1.5v0 c0,0.4,0.2,0.8,0.4,1.1L0.9,3L0.4,3.4C0.2,3.7,0,4.1,0,4.5v0C0,5.3,0.7,6,1.5,6h0c0.4,0,0.8-0.2,1.1-0.4L3,5.1z"/>',
    rotate: false,
    preview: `<path d="M0.5,0.9L0.5,0.9C0.6,1,0.7,1,0.7,1s0.1,0,0.2-0.1C1,0.8,1,0.7,0.9,0.6L0.9,0.5l0.1-0.1C1,0.3,1,0.2,0.9,0.1 S0.7,0,0.6,0.1L0.5,0.1L0.4,0.1C0.3,0,0.2,0,0.1,0.1C0,0.2,0,0.3,0.1,0.4l0.1,0.1L0.1,0.6C0,0.7,0,0.8,0.1,0.9C0.1,1,0.2,1,0.3,1 C0.3,1,0.4,1,0.5,0.9L0.5,0.9z"/> <path d="M2.1,0.9C2.1,1,2.2,1,2.3,1c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C2.6,1,2.7,1,2.7,1s0.1,0,0.2-0.1 C3,0.8,3,0.7,2.9,0.6L2.9,0.5l0.1-0.1C3,0.3,3,0.2,2.9,0.1S2.7,0,2.6,0.1L2.5,0.1L2.4,0.1C2.3,0,2.2,0,2.1,0.1S2,0.3,2.1,0.4 l0.1,0.1L2.1,0.6C2,0.7,2,0.8,2.1,0.9z"/> <path d="M4.9,0.5L4.9,0.5C5,0.4,5,0.3,5,0.3s0-0.1-0.1-0.2C4.8,0,4.7,0,4.6,0.1L4.5,0.1L4.4,0.1C4.3,0,4.2,0,4.1,0.1 S4,0.3,4.1,0.4l0.1,0.1L4.1,0.6C4,0.7,4,0.8,4.1,0.9C4.1,1,4.2,1,4.3,1c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C4.6,1,4.7,1,4.7,1 s0.1,0,0.2-0.1C5,0.9,5,0.8,5,0.7C5,0.7,5,0.6,4.9,0.5L4.9,0.5z"/> <path d="M5.9,0.5L5.9,0.5C6,0.3,6,0.2,5.9,0.1S5.7,0,5.6,0.1L5.5,0.1L5.4,0.1C5.3,0,5.2,0,5.1,0.1C5,0.1,5,0.2,5,0.3 s0,0.1,0.1,0.2l0.1,0.1L5.1,0.6C5,0.6,5,0.7,5,0.7c0,0.1,0,0.1,0.1,0.2C5.1,1,5.2,1,5.3,1c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1 C5.6,1,5.7,1,5.7,1s0.1,0,0.2-0.1C6,0.8,6,0.7,5.9,0.5L5.9,0.5z"/> <path d="M4.5,1.1L4.5,1.1C4.4,1,4.3,1,4.3,1S4.1,1,4.1,1.1C4,1.1,4,1.2,4,1.3s0,0.1,0.1,0.2l0.1,0.1L4.1,1.6 C4,1.6,4,1.7,4,1.7c0,0.1,0,0.1,0.1,0.2C4.1,2,4.2,2,4.3,2c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C4.6,2,4.7,2,4.7,2s0.1,0,0.2-0.1 C5,1.8,5,1.7,4.9,1.6L4.9,1.5l0.1-0.1C5,1.3,5,1.2,4.9,1.1C4.9,1,4.8,1,4.7,1C4.7,1,4.6,1,4.5,1.1L4.5,1.1z"/> <path d="M3.9,1.5L3.9,1.5C4,1.4,4,1.3,4,1.3s0-0.1-0.1-0.2C3.8,1,3.7,1,3.6,1.1L3.5,1.1L3.4,1.1C3.3,1,3.2,1,3.1,1.1 C3,1.2,3,1.3,3.1,1.4l0.1,0.1L3.1,1.6C3,1.7,3,1.8,3.1,1.9C3.1,2,3.2,2,3.3,2c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1 C3.6,2,3.7,2,3.7,2s0.1,0,0.2-0.1C4,1.9,4,1.8,4,1.7C4,1.7,4,1.6,3.9,1.5L3.9,1.5z"/> <path d="M2.1,2.9C2.1,3,2.2,3,2.3,3c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C2.6,3,2.7,3,2.7,3s0.1,0,0.2-0.1 C3,2.8,3,2.7,2.9,2.6L2.9,2.5l0.1-0.1C3,2.3,3,2.2,2.9,2.1C2.8,2,2.7,2,2.6,2.1L2.5,2.1L2.4,2.1C2.3,2,2.2,2,2.1,2.1 C2,2.2,2,2.3,2.1,2.4l0.1,0.1L2.1,2.6C2,2.7,2,2.8,2.1,2.9z"/> <path d="M0.1,1.9C0.1,2,0.2,2,0.3,2c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C0.6,2,0.7,2,0.7,2s0.1,0,0.2-0.1 C1,1.8,1,1.7,0.9,1.6L0.9,1.5l0.1-0.1C1,1.3,1,1.2,0.9,1.1C0.9,1,0.8,1,0.7,1C0.7,1,0.6,1,0.6,1.1L0.5,1.1L0.4,1.1 C0.4,1,0.3,1,0.3,1S0.1,1,0.1,1.1C0,1.2,0,1.3,0.1,1.4l0.1,0.1L0.1,1.6C0,1.7,0,1.8,0.1,1.9z"/> <path d="M0.9,3.5L0.9,3.5C1,3.4,1,3.3,1,3.3s0-0.1-0.1-0.2C0.8,3,0.7,3,0.6,3.1L0.5,3.1L0.4,3.1C0.3,3,0.2,3,0.1,3.1 C0,3.2,0,3.3,0.1,3.4l0.1,0.1L0.1,3.6C0,3.7,0,3.8,0.1,3.9C0.1,4,0.2,4,0.3,4c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1 C0.6,4,0.7,4,0.7,4s0.1,0,0.2-0.1C1,3.9,1,3.8,1,3.7C1,3.7,1,3.6,0.9,3.5L0.9,3.5z"/> <path d="M1.9,3.6L1.9,3.6V3.4C2,3.3,2,3.2,1.9,3.1C1.8,3,1.7,3,1.6,3.1L1.5,3.1L1.4,3.1C1.3,3,1.2,3,1.1,3.1 C1,3.1,1,3.2,1,3.3s0,0.1,0.1,0.2l0.1,0.1L1.1,3.6C1,3.6,1,3.7,1,3.7c0,0.1,0,0.1,0.1,0.2C1.1,4,1.2,4,1.3,4c0.1,0,0.1,0,0.2-0.1 l0.1-0.1l0.1,0.1C1.6,4,1.7,4,1.7,4s0.1,0,0.2-0.1C2,3.8,2,3.7,1.9,3.6z"/> <path d="M4.9,3.6L4.9,3.6V3.4C5,3.3,5,3.2,4.9,3.1C4.8,3,4.7,3,4.6,3.1L4.5,3.1L4.4,3.1C4.3,3,4.2,3,4.1,3.1 C4,3.2,4,3.3,4.1,3.4l0.1,0.1L4.1,3.6C4,3.7,4,3.8,4.1,3.9C4.1,4,4.2,4,4.3,4c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1 C4.6,4,4.7,4,4.7,4s0.1,0,0.2-0.1C5,3.8,5,3.7,4.9,3.6z"/> <path d="M5.9,4.1C5.8,4,5.7,4,5.6,4.1L5.5,4.1L5.4,4.1C5.3,4,5.2,4,5.1,4.1C5,4.2,5,4.3,5.1,4.4l0.1,0.1L5.1,4.6 C5,4.7,5,4.8,5.1,4.9C5.1,5,5.2,5,5.3,5c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C5.6,5,5.7,5,5.7,5s0.1,0,0.2-0.1C6,4.8,6,4.7,5.9,4.6 L5.9,4.5l0.1-0.1C6,4.3,6,4.2,5.9,4.1z"/> <path d="M3.9,5.1C3.8,5,3.7,5,3.6,5.1L3.5,5.1L3.4,5.1C3.3,5,3.2,5,3.1,5.1C3,5.1,3,5.2,3,5.3s0,0.1,0.1,0.2l0.1,0.1 L3.1,5.6C3,5.6,3,5.7,3,5.7c0,0.1,0,0.1,0.1,0.2C3.1,6,3.2,6,3.3,6c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C3.6,6,3.7,6,3.7,6 s0.1,0,0.2-0.1C4,5.8,4,5.7,3.9,5.6L3.9,5.5l0.1-0.1C4,5.3,4,5.2,3.9,5.1z"/> <path d="M2.9,5.5L2.9,5.5C3,5.4,3,5.3,3,5.3s0-0.1-0.1-0.2C2.8,5,2.7,5,2.6,5.1L2.5,5.1L2.4,5.1C2.3,5,2.2,5,2.1,5.1 C2,5.2,2,5.3,2.1,5.4l0.1,0.1L2.1,5.6C2,5.7,2,5.8,2.1,5.9C2.1,6,2.2,6,2.3,6c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1 C2.6,6,2.7,6,2.7,6s0.1,0,0.2-0.1C3,5.9,3,5.8,3,5.7C3,5.7,3,5.6,2.9,5.5L2.9,5.5z"/> <path d="M0.9,5.1C0.8,5,0.7,5,0.6,5.1L0.5,5.1L0.4,5.1C0.3,5,0.2,5,0.1,5.1C0,5.2,0,5.3,0.1,5.4l0.1,0.1L0.1,5.6 C0,5.7,0,5.8,0.1,5.9C0.1,6,0.2,6,0.3,6c0.1,0,0.1,0,0.2-0.1l0.1-0.1l0.1,0.1C0.6,6,0.7,6,0.7,6s0.1,0,0.2-0.1C1,5.8,1,5.7,0.9,5.6 L0.9,5.5l0.1-0.1C1,5.3,1,5.2,0.9,5.1z"/>`,
    marker: true,
  },
  heart: {
    path: '<path d="M6,1.8C5.9,1,5.3,0.4,4.5,0.3C3.9,0.2,3.4,0.5,3,0.9C2.6,0.5,2.1,0.3,1.6,0.3C0.8,0.4,0.1,1,0,1.8 C0,2.3,0.1,2.7,0.3,3l0,0l0,0c0.1,0.1,0.2,0.2,0.3,0.3l1.9,2.2c0.3,0.3,0.7,0.3,0.9,0l1.8-1.9c0.1-0.1,0.3-0.3,0.4-0.5 C5.9,2.8,6.1,2.3,6,1.8z"/>',
    rotate: false,
    preview: `<path d="M0.8,0C0.7,0,0.6,0,0.5,0.1C0.4,0,0.4,0,0.3,0C0.1,0,0,0.1,0,0.3c0,0.1,0,0.1,0,0.2l0,0L0.5,1l0.4-0.5 C1,0.4,1,0.3,1,0.3C1,0.1,0.9,0,0.8,0z"/> <path d="M2.8,0C2.7,0,2.6,0,2.5,0.1C2.4,0,2.4,0,2.3,0C2.1,0,2,0.1,2,0.3c0,0.1,0,0.1,0,0.2l0,0L2.5,1l0.4-0.5 C3,0.4,3,0.3,3,0.3C3,0.1,2.9,0,2.8,0z"/> <path d="M4.8,0C4.7,0,4.6,0,4.5,0.1C4.4,0,4.4,0,4.3,0C4.1,0,4,0.1,4,0.3c0,0.1,0,0.1,0,0.2l0,0L4.5,1l0.4-0.5 C5,0.4,5,0.3,5,0.3C5,0.1,4.9,0,4.8,0z"/> <path d="M5,0.5L5.5,1l0.4-0.5C6,0.4,6,0.3,6,0.3C6,0.1,5.9,0,5.8,0C5.7,0,5.6,0,5.5,0.1C5.4,0,5.4,0,5.3,0 C5.1,0,5,0.1,5,0.3C5,0.3,5,0.4,5,0.5L5,0.5z"/> <path d="M4.8,1C4.7,1,4.6,1,4.5,1.1C4.4,1,4.4,1,4.3,1C4.1,1,4,1.1,4,1.3c0,0.1,0,0.1,0,0.2l0,0L4.5,2l0.4-0.5 C5,1.4,5,1.3,5,1.3C5,1.1,4.9,1,4.8,1z"/> <path d="M3.8,1C3.7,1,3.6,1,3.5,1.1C3.4,1,3.4,1,3.3,1C3.1,1,3,1.1,3,1.3c0,0.1,0,0.1,0,0.2l0,0L3.5,2l0.4-0.5 C4,1.4,4,1.3,4,1.3C4,1.1,3.9,1,3.8,1z"/> <path d="M2.8,2C2.7,2,2.6,2,2.5,2.1C2.4,2,2.4,2,2.3,2C2.1,2,2,2.1,2,2.3c0,0.1,0,0.1,0,0.2l0,0L2.5,3l0.4-0.5 C3,2.4,3,2.3,3,2.3C3,2.1,2.9,2,2.8,2z"/> <path d="M0.8,1C0.7,1,0.6,1,0.5,1.1C0.4,1,0.4,1,0.3,1C0.1,1,0,1.1,0,1.3c0,0.1,0,0.1,0,0.2l0,0L0.5,2l0.4-0.5 C1,1.4,1,1.3,1,1.3C1,1.1,0.9,1,0.8,1z"/> <path d="M0.8,3C0.7,3,0.6,3,0.5,3.1C0.4,3,0.4,3,0.3,3C0.1,3,0,3.1,0,3.3c0,0.1,0,0.1,0,0.2l0,0L0.5,4l0.4-0.5 C1,3.4,1,3.3,1,3.3C1,3.1,0.9,3,0.8,3z"/> <path d="M1.8,3C1.7,3,1.6,3,1.5,3.1C1.4,3,1.4,3,1.3,3C1.1,3,1,3.1,1,3.3c0,0.1,0,0.1,0,0.2l0,0L1.5,4l0.4-0.5 C2,3.4,2,3.3,2,3.3C2,3.1,1.9,3,1.8,3z"/> <path d="M4.8,3C4.7,3,4.6,3,4.5,3.1C4.4,3,4.4,3,4.3,3C4.1,3,4,3.1,4,3.3c0,0.1,0,0.1,0,0.2l0,0L4.5,4l0.4-0.5 C5,3.4,5,3.3,5,3.3C5,3.1,4.9,3,4.8,3z"/> <path d="M5.8,4C5.7,4,5.6,4,5.5,4.1C5.4,4,5.4,4,5.3,4C5.1,4,5,4.1,5,4.3c0,0.1,0,0.1,0,0.2l0,0L5.5,5l0.4-0.5 C6,4.4,6,4.3,6,4.3C6,4.1,5.9,4,5.8,4z"/> <path d="M3.8,5C3.7,5,3.6,5,3.5,5.1C3.4,5,3.4,5,3.3,5C3.1,5,3,5.1,3,5.3c0,0.1,0,0.1,0,0.2l0,0L3.5,6l0.4-0.5 C4,5.4,4,5.3,4,5.3C4,5.1,3.9,5,3.8,5z"/> <path d="M2.8,5C2.7,5,2.6,5,2.5,5.1C2.4,5,2.4,5,2.3,5C2.1,5,2,5.1,2,5.3c0,0.1,0,0.1,0,0.2l0,0L2.5,6l0.4-0.5 C3,5.4,3,5.3,3,5.3C3,5.1,2.9,5,2.8,5z"/> <path d="M0.8,5C0.7,5,0.6,5,0.5,5.1C0.4,5,0.4,5,0.3,5C0.1,5,0,5.1,0,5.3c0,0.1,0,0.1,0,0.2l0,0L0.5,6l0.4-0.5 C1,5.4,1,5.3,1,5.3C1,5.1,0.9,5,0.8,5z"/>`,
    marker: true,
  },
  shake: {
    path: '<rect x="0.5" y="0.5" width="5" height="5"/>',
    rotate: false,
    preview: `<rect x="0.1" y="0.1" transform="matrix(0.9962 -8.720575e-02 8.720575e-02 0.9962 -4.170330e-02 4.550928e-02)" width="0.8" height="0.8"/> <rect x="2.1" y="0.1" transform="matrix(6.981014e-02 -0.9976 0.9976 6.981014e-02 1.8266 2.9591)" width="0.8" height="0.8"/> <rect x="4.1" y="0.1" transform="matrix(0.1045 -0.9945 0.9945 0.1045 3.5323 4.9232)" width="0.8" height="0.8"/> <rect x="5.1" y="0.1" transform="matrix(0.9962 -8.713004e-02 8.713004e-02 0.9962 -2.265348e-02 0.4811)" width="0.8" height="0.8"/> <rect x="4.1" y="1.1" transform="matrix(0.9986 -5.233859e-02 5.233859e-02 0.9986 -7.234332e-02 0.2376)" width="0.8" height="0.8"/> <rect x="3.1" y="1.1" transform="matrix(0.1736 -0.9848 0.9848 0.1736 1.415 4.6864)" width="0.8" height="0.8"/> <rect x="2.1" y="2.1" transform="matrix(0.9962 -8.720575e-02 8.720575e-02 0.9962 -0.2085 0.2275)" width="0.8" height="0.8"/> <rect x="0.1" y="1.1" transform="matrix(5.233460e-02 -0.9986 0.9986 5.233460e-02 -1.0241 1.9209)" width="0.8" height="0.8"/> <rect x="0.1" y="3.1" transform="matrix(0.9998 -1.747158e-02 1.747158e-02 0.9998 -6.107527e-02 9.270038e-03)" width="0.8" height="0.8"/> <rect x="1.1" y="3.1" transform="matrix(3.486695e-02 -0.9994 0.9994 3.486695e-02 -2.0502 4.8771)" width="0.8" height="0.8"/> <rect x="4.1" y="3.1" transform="matrix(0.1564 -0.9877 0.9877 0.1564 0.3392 7.3973)" width="0.8" height="0.8"/> <rect x="5.1" y="4.1" transform="matrix(0.1045 -0.9945 0.9945 0.1045 0.4498 9.4996)" width="0.8" height="0.8"/> <rect x="3.1" y="5.1" transform="matrix(0.9962 -8.720575e-02 8.720575e-02 0.9962 -0.4663 0.3262)" width="0.8" height="0.8"/> <rect x="2.1" y="5.1" transform="matrix(8.719913e-02 -0.9962 0.9962 8.719913e-02 -3.1971 7.511)" width="0.8" height="0.8"/> <rect x="0.1" y="5.1" transform="matrix(8.719913e-02 -0.9962 0.9962 8.719913e-02 -5.0227 5.5186)" width="0.8" height="0.8"/>`,
  },
  blob: {
    path: '<circle cx="3" cy="3" r="3"/>',
    tb: '<path d="M4.3,5.7C5.3,5.2,6,4.2,6,3S5.3,0.8,4.3,0.3C4.1,0.2,4,0.1,4,0H2c0,0.1-0.1,0.2-0.3,0.3C0.7,0.8,0,1.8,0,3 s0.7,2.2,1.7,2.7C1.9,5.8,2,5.9,2,6h2C4,5.9,4.1,5.8,4.3,5.7z"/>',
    rl: '<path d="M0.3,4.3C0.8,5.3,1.8,6,3,6s2.2-0.7,2.7-1.7C5.8,4.1,5.9,4,6,4V2C5.9,2,5.8,1.9,5.7,1.7C5.2,0.7,4.2,0,3,0 S0.8,0.7,0.3,1.7C0.2,1.9,0.1,2,0,2v2C0.1,4,0.2,4.1,0.3,4.3z"/>',
    trbl: '<path d="M4,0H2c0,1.1-0.9,2-2,2v2c1.1,0,2,0.9,2,2h2c0-1.1,0.9-2,2-2V2C4.9,2,4,1.1,4,0z"/>',
    trl: '<path d="M4.6,1.4C4.6,1.4,4.6,1.4,4.6,1.4C4.3,1.1,4.1,0.8,4,0.4C4,0.3,4,0.1,4,0H2c0,0.1,0,0.3,0,0.4 c-0.1,0.4-0.3,0.7-0.5,1c0,0,0,0,0,0C1,1.8,0.5,2,0,2v2c0.5,0,1,0.2,1.3,0.5c0,0,0,0,0,0C1.8,5,2.3,5.2,3,5.2S4.2,5,4.6,4.5 c0,0,0,0,0,0C5,4.2,5.5,4,6,4V2C5.5,2,5,1.8,4.6,1.4z"/>',
    trb: '<path d="M4.6,4.6C4.6,4.6,4.6,4.6,4.6,4.6c0.3-0.3,0.6-0.5,1-0.6C5.7,4,5.9,4,6,4V2C5.9,2,5.7,2,5.6,2 c-0.4-0.1-0.7-0.3-1-0.5c0,0,0,0,0,0C4.2,1,4,0.5,4,0H2c0,0.5-0.2,1-0.5,1.3c0,0,0,0,0,0C1,1.8,0.8,2.3,0.8,3S1,4.2,1.5,4.6 c0,0,0,0,0,0C1.8,5,2,5.5,2,6h2C4,5.5,4.2,5,4.6,4.6z"/>',
    rbl: '<path d="M1.4,4.6C1.4,4.6,1.4,4.6,1.4,4.6c0.3,0.3,0.5,0.6,0.6,1C2,5.7,2,5.9,2,6h2c0-0.1,0-0.3,0-0.4 c0.1-0.4,0.3-0.7,0.5-1c0,0,0,0,0,0C5,4.2,5.5,4,6,4V2C5.5,2,5,1.8,4.7,1.5c0,0,0,0,0,0C4.2,1,3.7,0.8,3,0.8S1.8,1,1.4,1.5 c0,0,0,0,0,0C1,1.8,0.5,2,0,2v2C0.5,4,1,4.2,1.4,4.6z"/>',
    tbl: '<path d="M1.4,1.4C1.4,1.4,1.4,1.4,1.4,1.4C1.1,1.7,0.8,1.9,0.4,2C0.3,2,0.1,2,0,2v2c0.1,0,0.3,0,0.4,0 c0.4,0.1,0.7,0.3,1,0.5c0,0,0,0,0,0C1.8,5,2,5.5,2,6h2c0-0.5,0.2-1,0.5-1.3c0,0,0,0,0,0C5,4.2,5.2,3.7,5.2,3S5,1.8,4.5,1.4 c0,0,0,0,0,0C4.2,1,4,0.5,4,0H2C2,0.5,1.8,1,1.4,1.4z"/>',
    tr: '<path d="M4.6,1.4C4.6,1.4,4.6,1.4,4.6,1.4C4.2,1,4,0.5,4,0H2c0,0.5-0.2,1-0.5,1.3l0,0C1,1.8,0.8,2.3,0.8,3 c0,1.2,1,2.2,2.2,2.2c0.6,0,1.1-0.2,1.5-0.6l0,0C4.9,4.2,5.4,4,6,4V2C5.5,2,5,1.8,4.6,1.4z"/>',
    rb: '<path d="M4.6,4.6C4.6,4.6,4.6,4.6,4.6,4.6C5,4.2,5.5,4,6,4V2C5.5,2,5,1.8,4.7,1.5l0,0C4.2,1,3.7,0.8,3,0.8 c-1.2,0-2.2,1-2.2,2.2c0,0.6,0.2,1.1,0.6,1.5l0,0C1.8,4.9,2,5.4,2,6h2C4,5.5,4.2,5,4.6,4.6z"/>',
    bl: '<path d="M1.4,4.6C1.4,4.6,1.4,4.6,1.4,4.6C1.8,5,2,5.5,2,6h2c0-0.5,0.2-1,0.5-1.3l0,0C5,4.2,5.2,3.7,5.2,3 c0-1.2-1-2.2-2.2-2.2C2.4,0.8,1.9,1,1.5,1.4l0,0C1.1,1.8,0.6,2,0,2v2C0.5,4,1,4.2,1.4,4.6z"/>',
    tl: '<path d="M1.4,1.4C1.4,1.4,1.4,1.4,1.4,1.4C1,1.8,0.5,2,0,2v2c0.5,0,1,0.2,1.3,0.5l0,0C1.8,5,2.3,5.2,3,5.2 c1.2,0,2.2-1,2.2-2.2c0-0.6-0.2-1.1-0.6-1.5l0,0C4.2,1.1,4,0.6,4,0H2C2,0.5,1.8,1,1.4,1.4z"/>',
    t: '<path d="M0.8,3c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2c0-0.6-0.3-1.2-0.7-1.6C4.2,1,4,0.5,4,0H2c0,0.5-0.2,1-0.6,1.4 C1,1.8,0.8,2.4,0.8,3z"/>',
    r: '<path d="M3,0.8c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c0.6,0,1.2-0.3,1.6-0.7C5,4.2,5.5,4,6,4V2C5.5,2,5,1.8,4.6,1.4 C4.2,1,3.6,0.8,3,0.8z"/>',
    b: '<path d="M5.2,3c0-1.2-1-2.2-2.2-2.2S0.8,1.8,0.8,3c0,0.6,0.3,1.2,0.7,1.6C1.8,5,2,5.5,2,6h2c0-0.5,0.2-1,0.6-1.4 C5,4.2,5.2,3.6,5.2,3z"/>',
    l: '<path d="M3,5.2c1.2,0,2.2-1,2.2-2.2S4.2,0.8,3,0.8C2.4,0.8,1.8,1,1.4,1.4C1,1.8,0.5,2,0,2v2c0.5,0,1,0.2,1.4,0.6 C1.8,5,2.4,5.2,3,5.2z"/>',
    rotate: false,
    preview: `<circle cx="5.5" cy="4.5" r="0.5"/> <path d="M5.8,0.2C5.7,0.2,5.6,0.1,5.5,0.1c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4c0.1,0,0.2,0,0.3-0.1 C5.8,0.7,5.9,0.7,6,0.7V0.3C5.9,0.3,5.8,0.3,5.8,0.2z"/> <path d="M3.9,4.5c0-0.2-0.2-0.4-0.4-0.4c-0.1,0-0.2,0-0.3,0.1C3.2,4.3,3.1,4.3,3,4.3c-0.1,0-0.2,0-0.2-0.1 C2.7,4.2,2.6,4.1,2.5,4.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.1,0,0.2,0.1,0.3C2.3,4.8,2.3,4.9,2.3,5c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0-0.1,0 C1.9,5.1,1.7,5,1.5,5S1.1,5.1,1.1,5.3c0,0,0,0-0.1,0v0c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0,0C0.7,5.2,0.7,5.1,0.7,5c0,0,0,0,0-0.1 C0.9,4.9,1,4.7,1,4.5S0.9,4.1,0.7,4.1c0,0,0,0,0-0.1h0c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2-0.2-0.4-0.4-0.4 S0.1,3.3,0.1,3.5c0,0.1,0,0.2,0.1,0.3C0.3,3.8,0.3,3.9,0.3,4c0,0,0,0,0,0.1C0.1,4.1,0,4.3,0,4.5s0.1,0.4,0.3,0.4c0,0,0,0,0,0 c0,0,0,0,0,0c0,0.1,0,0.2-0.1,0.2C0.2,5.3,0.1,5.4,0.1,5.5c0,0.2,0.2,0.4,0.4,0.4c0.1,0,0.2,0,0.3-0.1C0.8,5.7,0.9,5.7,1,5.7v0 c0,0,0,0,0.1,0C1.1,5.9,1.3,6,1.5,6s0.4-0.1,0.4-0.3c0,0,0,0,0.1,0c0.2,0,0.3,0.1,0.3,0.3h0.3c0-0.2,0.1-0.3,0.3-0.3h0 c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0,0C3.3,5.8,3.3,5.9,3.3,6h0.3c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0,0 c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3c0,0,0,0,0,0C3.7,5.2,3.7,5.1,3.7,5h0c0-0.1,0-0.2,0.1-0.2C3.8,4.7,3.9,4.6,3.9,4.5z M3.2,5.2C3.2,5.2,3.2,5.2,3.2,5.2c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0h0C2.8,5.3,2.7,5.2,2.7,5c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0,0 C2.8,4.7,2.9,4.7,3,4.7s0.2,0,0.2,0.1c0,0,0,0,0,0C3.3,4.8,3.3,4.9,3.3,5h0C3.3,5.1,3.3,5.2,3.2,5.2z"/> <path d="M5.2,2.8c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.2,0.4-0.4S5.7,2.1,5.5,2.1c-0.1,0-0.2,0-0.3,0.1 C5.2,2.3,5.1,2.3,5,2.3c0,0,0,0,0,0v0c0,0,0,0-0.1,0C4.9,2.1,4.7,2,4.5,2C4.3,2,4.1,2.1,4.1,2.3c0,0,0,0-0.1,0 c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0,0C3.7,2.2,3.7,2.1,3.7,2c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0,0c0.1-0.1,0.1-0.2,0.1-0.3 c0-0.1,0-0.2-0.1-0.3c0,0,0,0,0,0C3.7,1.2,3.7,1.1,3.7,1c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2-0.2-0.4-0.4-0.4 c-0.2,0-0.4,0.2-0.4,0.4c0,0.1,0,0.2,0.1,0.3C3.3,0.8,3.3,0.9,3.3,1c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0C3.2,1.3,3.1,1.4,3.1,1.5 c0,0.1,0,0.2,0.1,0.3c0,0,0,0,0,0C3.3,1.8,3.3,1.9,3.3,2c0,0.1,0,0.2-0.1,0.2C3.2,2.3,3.1,2.4,3.1,2.5c0,0.2,0.2,0.4,0.4,0.4 c0.1,0,0.2,0,0.3-0.1C3.8,2.7,3.9,2.7,4,2.7c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0.1,0C4.1,2.9,4.3,3,4.5,3c0.2,0,0.4-0.1,0.4-0.3 c0,0,0,0,0.1,0c0,0,0,0,0,0C5.1,2.7,5.2,2.7,5.2,2.8z"/> <path d="M0.5,0.9c0.1,0,0.2,0,0.3-0.1C0.8,0.7,0.9,0.7,1,0.7c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0,0 C1.3,0.8,1.3,0.9,1.3,1h0c0,0,0,0,0,0.1C1.1,1.1,1,1.3,1,1.5s0.1,0.4,0.3,0.4c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.2-0.1,0.2 C1.2,2.3,1.1,2.4,1.1,2.5c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-0.1,0-0.2-0.1-0.3C1.7,2.2,1.7,2.1,1.7,2c0,0,0,0,0,0 c0,0,0,0,0,0C1.9,1.9,2,1.7,2,1.5S1.9,1.1,1.7,1.1c0,0,0,0,0-0.1v0c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0,0c0.1-0.1,0.1-0.2,0.1-0.3 c0-0.1,0-0.2-0.1-0.3c0,0,0,0,0,0C1.7,0.2,1.7,0.1,1.7,0H1.3c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0 c-0.1,0-0.2,0-0.2-0.1C0.7,0.2,0.6,0.1,0.5,0.1c-0.2,0-0.4,0.2-0.4,0.4S0.3,0.9,0.5,0.9z"/>`,
  },
  "special-circle-orizz": {
    path: '<circle cx="3" cy="3" r="2.5"/>',
    trbl: '<rect y="0.5" width="6" height="5"/>',
    rb: '<path d="M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"/>',
    bl: '<path d="M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"/>',
    tr: '<path d="M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"/>',
    tl: '<path d="M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"/>',
    t: '<circle cx="3" cy="3" r="2.5"/>',
    r: '<path d="M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"/>',
    trb: '<path d="M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"/>',
    b: '<circle cx="3" cy="3" r="2.5"/>',
    l: '<path d="M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"/>',
    tbl: '<path d="M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"/>',
    tb: '<circle cx="3" cy="3" r="2.5"/>',
    rl: '<rect y="0.5" width="6" height="5"/>',
    rotate: false,
    preview: `<path d="M0.5,0.9l1,0c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4l-1,0c-0.2,0-0.4,0.2-0.4,0.4S0.3,0.9,0.5,0.9z"/> <path d="M1.5,1.9l2,0c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4l-2,0c-0.2,0-0.4,0.2-0.4,0.4S1.3,1.9,1.5,1.9z"/> <path d="M3.5,0.9c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4S3.1,0.3,3.1,0.5C3.1,0.7,3.3,0.9,3.5,0.9z"/> <path d="M4.5,2.1l-3,0c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4l3,0c0.2,0,0.4-0.2,0.4-0.4S4.7,2.1,4.5,2.1z"/> <path d="M1.9,3.5c0-0.2-0.2-0.4-0.4-0.4H0v0.8h1.5C1.7,3.9,1.9,3.7,1.9,3.5z"/> <path d="M4.5,3.1c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S4.7,3.1,4.5,3.1z"/> <path d="M5.9,4.5c0-0.2-0.2-0.4-0.4-0.4l-1,0c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4l1,0C5.7,4.9,5.9,4.7,5.9,4.5z"/> <path d="M3.5,4.1l-2,0c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4l2,0c0.2,0,0.4-0.2,0.4-0.4S3.7,4.1,3.5,4.1z"/> <path d="M2.5,5.1l-2,0c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4l2,0c0.2,0,0.4-0.2,0.4-0.4S2.7,5.1,2.5,5.1z"/> <path d="M6,0.1l-1.5,0c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4l1.5,0h0L6,0.1L6,0.1z"/> <path d="M5.1,5.5c0,0.2,0.2,0.4,0.4,0.4H6V5.1H5.5C5.3,5.1,5.1,5.3,5.1,5.5z"/>`,
  },
  "special-circle-vert": {
    path: '<circle cx="3" cy="3" r="2.5"/>',
    trbl: '<rect x="0.5" width="5" height="6"/>',
    rb: '<path d="M5.5,6h-5V3c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5V6z"/>',
    bl: '<path d="M5.5,6h-5V3c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5V6z"/>',
    tr: '<path d="M3,5.5L3,5.5C1.6,5.5,0.5,4.4,0.5,3V0h5v3C5.5,4.4,4.4,5.5,3,5.5z"/>',
    tl: '<path d="M3,5.5L3,5.5C1.6,5.5,0.5,4.4,0.5,3V0h5v3C5.5,4.4,4.4,5.5,3,5.5z"/>',
    t: '<path d="M3,5.5L3,5.5C1.6,5.5,0.5,4.4,0.5,3V0h5v3C5.5,4.4,4.4,5.5,3,5.5z"/>',
    r: '<circle cx="3" cy="3" r="2.5"/>',
    rbl: '<path d="M5.5,6h-5V3c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5V6z"/>',
    b: '<path d="M5.5,6h-5V3c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5V6z"/>',
    l: '<circle cx="3" cy="3" r="2.5"/>',
    trl: '<path d="M3,5.5L3,5.5C1.6,5.5,0.5,4.4,0.5,3V0h5v3C5.5,4.4,4.4,5.5,3,5.5z"/>',
    tb: '<rect x="0.5" width="5" height="6"/>',
    rl: '<circle cx="3" cy="3" r="2.5"/>',
    rotate: false,
    preview: `<path d="M0.5,4.1c-0.2,0-0.4,0.2-0.4,0.4l0,1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4l0-1C0.9,4.3,0.7,4.1,0.5,4.1z"/> <path d="M1.5,2.1c-0.2,0-0.4,0.2-0.4,0.4l0,2c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4l0-2C1.9,2.3,1.7,2.1,1.5,2.1z"/> <path d="M0.5,2.9c0.2,0,0.4-0.2,0.4-0.4S0.7,2.1,0.5,2.1c-0.2,0-0.4,0.2-0.4,0.4S0.3,2.9,0.5,2.9z"/> <path d="M2.5,1.1c-0.2,0-0.4,0.2-0.4,0.4l0,3c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4l0-3C2.9,1.3,2.7,1.1,2.5,1.1z"/> <path d="M3.5,4.1c-0.2,0-0.4,0.2-0.4,0.4V6h0.8V4.5C3.9,4.3,3.7,4.1,3.5,4.1z"/> <path d="M3.5,1.1c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4S3.7,1.1,3.5,1.1z"/> <path d="M4.5,1.9c0.2,0,0.4-0.2,0.4-0.4l0-1c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4l0,1 C4.1,1.7,4.3,1.9,4.5,1.9z"/> <path d="M4.5,2.1c-0.2,0-0.4,0.2-0.4,0.4l0,2c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4l0-2C4.9,2.3,4.7,2.1,4.5,2.1z"/> <path d="M5.5,3.1c-0.2,0-0.4,0.2-0.4,0.4l0,2c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4l0-2 C5.9,3.3,5.7,3.1,5.5,3.1z"/> <path d="M0.1,0l0,1.5c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4l0-1.5v0L0.1,0L0.1,0z"/> <path d="M5.5,0.9c0.2,0,0.4-0.2,0.4-0.4V0H5.1v0.5C5.1,0.7,5.3,0.9,5.5,0.9z"/>`,
  },
  "special-circle": {
    path: '<circle cx="3" cy="3" r="3"/>',
    tb: '<rect width="6" height="6"/>',
    rl: '<rect width="6" height="6"/>',
    trbl: '<rect width="6" height="6"/>',
    rb: '<path d="M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"/>',
    bl: '<path d="M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"/>',
    tr: '<path d="M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"/>',
    tl: '<path d="M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"/>',
    t: '<path d="M3,6L3,6C1.3,6,0,4.7,0,3V0h6v3C6,4.7,4.7,6,3,6z"/>',
    r: '<path d="M6,6H3C1.3,6,0,4.7,0,3v0c0-1.7,1.3-3,3-3h3C6,0,6,6,6,6z"/>',
    b: '<path d="M6,6H0V3c0-1.7,1.3-3,3-3h0c1.7,0,3,1.3,3,3V6z"/>',
    l: '<path d="M3,6H0V0l3,0c1.7,0,3,1.3,3,3v0C6,4.7,4.7,6,3,6z"/>',
    rotate: false,
    preview: `<path d="M2.5,3C2.8,3,3,2.8,3,2.5L3,2h1.5C4.8,2,5,1.8,5,1.5C5,1.2,4.8,1,4.5,1H4V0L2,0l0,2.5C2,2.8,2.2,3,2.5,3z M4,1 L4,1L4,1L4,1z"/> <path d="M5.5,3C5.2,3,5,3.2,5,3.5S5.2,4,5.5,4C5.8,4,6,3.8,6,3.5S5.8,3,5.5,3z"/> <path d="M0.5,1C0.8,1,1,0.8,1,0.5V0L0,0v0v0.5C0,0.8,0.2,1,0.5,1z"/> <path d="M4,4L4,4L3,4l0,0v0C2.4,4,2,4.4,2,5h0H1V2.5C1,2.2,0.8,2,0.5,2S0,2.2,0,2.5V5h0c0,0.6,0.4,1,1,1h2v0V5h1v0h0v1 l1,0V5h0C5,4.4,4.6,4,4,4z"/>`,
  },
  "special-diamond": {
    path: '<polyline points="6,3 3,6 0,3 3,0 "/>',
    trbl: '<rect width="6" height="6"/>',
    tb: '<rect width="6" height="6"/>',
    rl: '<rect width="6" height="6"/>',
    rb: '<polygon points="3,0 6,0 6,3 6,6 3,6 0,6 0,3 "/>',
    bl: '<polygon points="6,3 6,6 3,6 0,6 0,3 0,0 3,0 "/>',
    tr: '<polygon points="0,3 0,0 3,0 6,0 6,3 6,6 3,6 "/>',
    tl: '<polygon points="3,6 0,6 0,3 0,0 3,0 6,0 6,3 "/>',
    t: '<polygon points="6,3 3,6 0,3 0,3 0,0 3,0 6,0 6,3 "/>',
    r: '<polygon points="6,6 3,6 3,6 0,3 3,0 3,0 6,0 6,3 "/>',
    b: '<polygon points="6,6 3,6 0,6 0,3 0,3 3,0 6,3 6,3 "/>',
    l: '<polygon points="3,6 3,6 0,6 0,3 0,0 3,0 3,0 6,3 "/>',
    rotate: false,
    preview: `<rect x="4.1" y="3.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.1563 4.2076)" width="0.7" height="0.7"/> <polygon points="1,1.5 1,1 1,1 2.5,1 3,0.5 2.5,0 0.5,0 0,0.5 0,1.5 0.5,2 "/> <path d="M3,2"/> <rect x="5.1" y="4.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.5707 5.2069)" width="0.7" height="0.7"/> <polygon points="0.5,3 0,3.5 0,5.5 0.5,6 1,5.5 1,4 2,4 2,5.5 2.5,6 4.5,6 5,5.5 4.5,5 3,5 3,3.5 2.5,3"/> <polygon points="5.5,0 4.5,0 4,0.5 4,1 3.5,1 3,1.5 3,2.5 3.5,3 4,2.5 4,2 4.5,2 5,1.5 5,1 5.5,1 6,0.5"/>`,
  },
  ribbon: {
    path: '<rect width="6" height="6"/>',
    rotate: false,
    t: '<polygon points="6,6 3,3 0,6 0,0 6,0 "/>',
    r: '<polygon points="6,6 0,6 3,3 0,0 6,0 "/>',
    b: '<polygon points="6,6 0,6 0,0 3,3 6,0 "/>',
    l: '<polygon points="6,6 0,6 0,0 6,0 3,3 "/>',
    preview: `<rect x="4" y="3" width="1" height="1"/> <rect x="5" y="4" width="1" height="1"/> <polygon points="5,1 6,1 6,1 6,1 5.5,0.5 6,0 4,0 4,0 4,0 4,1 4,1 4,1 3,1 2.5,0.5 3,0 3,0 3,0 0,0 0,2 0,2 0,2 0.5,1.5 1,2 1,2 1,2 1,1 1,1 3,1 3,3 0,3 0,6 0,6 0,6 0.5,5.5 1,6 1,6 1,4 2,4 2,6 6,6 6,6 5,6 4.5,5.5 5,5 5,5 5,5 3,5 3,3 3.5,2.5 4,3 4,3 4,3 4,2 5,2 5,2 5,2"/>`,
  },
  oriental: {
    path: '<circle cx="3" cy="3" r="3"/>',
    tb: '<rect width="6" height="6"/>',
    rl: '<rect width="6" height="6"/>',
    trbl: '<rect width="6" height="6"/>',
    rb: '<path d="M6,6H0V3c0-1.7,1.3-3,3-3l3,0V6z"/>',
    bl: '<path d="M6,6H0V0l3,0c1.7,0,3,1.3,3,3V6z"/>',
    tr: '<path d="M6,6H3C1.3,6,0,4.7,0,3V0l6,0V6z"/>',
    tl: '<path d="M3,6H0V0l6,0v3C6,4.7,4.7,6,3,6z"/>',
    t: '<path d="M0,0l0.4,1.3c0.4,1.1,0.4,2.4,0,3.5L0,6c3.3,0,6-2.7,6-6H0z"/>',
    r: '<path d="M4.7,0.4c-1.1,0.4-2.4,0.4-3.5,0L0,0c0,3.3,2.7,6,6,6V0L4.7,0.4z"/>',
    b: '<path d="M6,6H0v0c0-3.3,2.7-6,6-6h0L5.6,1.3c-0.4,1.1-0.4,2.4,0,3.5L6,6z"/>',
    l: '<path d="M0,0v6l1.3-0.4c1.1-0.4,2.4-0.4,3.5,0L6,6C6,2.7,3.3,0,0,0z"/>',
    rotate: false,
    preview: `<path d="M5.5,4C5.2,4,5,4.2,5,4.5S5.2,5,5.5,5C5.8,5,6,4.8,6,4.5S5.8,4,5.5,4z"/> <path d="M0,2c0.6,0,1-0.4,1-1l1,0v0l0.2-0.1c0.2-0.1,0.4-0.1,0.6,0L3,1c0,0,0,0,0,0v0l0,0c0-0.6-0.4-1-1-1v0H0l0,1h0l0.1,0.2 c0.1,0.2,0.1,0.4,0,0.6L0,2z"/> <path d="M4.5,3C4.2,3,4,3.2,4,3.5S4.2,4,4.5,4C4.8,4,5,3.8,5,3.5S4.8,3,4.5,3z"/> <path d="M3,2L3,2L3,2l0.1,0.2c0.1,0.2,0.1,0.4,0,0.6L3,3c0.6,0,1-0.4,1-1l0,0h0h0.5C4.8,2,5,1.8,5,1.5V1l0.2-0.1 c0.2-0.1,0.4-0.1,0.6,0L6,1c0-0.6-0.4-1-1-1l0,0h0H4.5C4.2,0,4,0.2,4,0.5V1h0H3.5C3.2,1,3,1.2,3,1.5V2z"/> <path d="M4,5L4,5L3,5v0h0l0-1.5C3,3.2,2.8,3,2.5,3l-1,0C1.2,3,1,3.2,1,3.5L1,4l0,0L0.8,4.1c-0.2,0.1-0.4,0.1-0.6,0L0,4 c0,0.6,0.4,1,1,1l0,0l1,0l0,0.5C2,5.8,2.2,6,2.5,6L4,6l0,0v0l0.2-0.1c0.2-0.1,0.4-0.1,0.6,0L5,6C5,5.4,4.6,5,4,5z"/>`,
  },
  ellipse: {
    path: '<path d="M5.4,2.8C4.5,1.1,2.6-0.1,1.2,0c-1.3,0.1-1.6,1.6-0.7,3.2c1,1.7,2.8,2.9,4.2,2.8C6.1,5.9,6.4,4.4,5.4,2.8z"/>',
    tb: '<rect width="6" height="6"/>',
    rl: '<rect width="6" height="6"/>',
    trbl: '<rect width="6" height="6"/>',
    rb: '<path d="M6,6H0V2c0-1.1,0.9-2,2-2h4V6z"/>',
    bl: '<path d="M0,6V0h4c1.1,0,2,0.9,2,2v4H0z"/>',
    tr: '<path d="M6,0v6H2C0.9,6,0,5.1,0,4V0H6z"/>',
    tl: '<path d="M0,0h6v4c0,1.1-0.9,2-2,2H0V0z"/>',
    t: '<path d="M5.2,6L5.2,6C3.8,6,0,1.4,0,0l0,0h6v5.2C6,5.6,5.6,6,5.2,6z"/>',
    r: '<path d="M0,5.2L0,5.2C0,3.8,4.6,0,6,0l0,0v6H0.8C0.4,6,0,5.6,0,5.2z"/>',
    b: '<path d="M0.8,0L0.8,0C2.2,0,6,4.6,6,6l0,0H0V0.8C0,0.4,0.4,0,0.8,0z"/>',
    l: '<path d="M6,0.8L6,0.8C6,2.2,1.4,6,0,6l0,0V0h5.2C5.6,0,6,0.4,6,0.8z"/>',
    rotate: false,
    preview: `<path d="M5.2,4C5,4,4.9,4.3,5.1,4.5C5.3,4.8,5.6,5,5.8,5C6,5,6.1,4.7,5.9,4.5C5.7,4.2,5.4,4,5.2,4z"/> <path d="M5,0.9C5,0.9,5.1,1,5.1,1H6V0C5.8,0,5,0.6,5,0.9z"/> <path d="M5.9,2H4l0,0h0V1l0,0h0c0-0.2-0.6-1-0.9-1C3.1,0,3,0.1,3,0.1v2.5C3,2.9,3.1,3,3.3,3L5,3v0l0,0c0.2,0,1-0.6,1-0.9 C6,2.1,5.9,2,5.9,2z"/> <path d="M3.7,4H2.3C2.1,4,2,4.1,2,4.3V5h0l0,0H1v0V4h0l0,0c0-0.2-0.6-1-0.9-1C0.1,3,0,3.1,0,3.1v2.5C0,5.9,0.1,6,0.3,6L4,6V4.3 C4,4.1,3.9,4,3.7,4z"/> <path d="M0.1,1H1v0v1h0l0,0c0,0.2,0.6,1,0.9,1C1.9,3,2,2.9,2,2.9L2,0H1v0C0.8,0,0,0.6,0,0.9C0,0.9,0.1,1,0.1,1z"/>`,
  },
  vortex: {
    path: '<path d="M3.5,6C0.7,4.7,1.7,3,0,3.5C1.3,0.7,3,1.7,2.5,0C5.3,1.3,4.3,3,6,2.5C4.7,5.3,3,4.3,3.5,6z"/>',
    rotate: false,
    marker: true,
  },
  sparkle_dot: {
    path: '<path d="M3-1L3-1c0,2.2-1.8,4-4,4h0h0c2.2,0,4,1.8,4,4v0v0c0-2.2,1.8-4,4-4h0h0C4.8,3,3,1.2,3-1L3-1z"/>',
    rotate: false,
    marker: true,
  },
  "9-dots": {
    path: '<circle cx="1" cy="1" r="1"/><circle cx="3" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="1" cy="3" r="1"/><circle cx="3" cy="3" r="1"/><circle cx="5" cy="3" r="1"/><circle cx="1" cy="5" r="1"/><circle cx="3" cy="5" r="1"/><circle cx="5" cy="5" r="1"/>',
    rotate: false,
    marker: true,
  },
  "9-dots-fat": {
    path: '<path d="M6,3c0-0.4-0.3-0.8-0.6-1C5.7,1.9,6,1.5,6,1.1C6,0.5,5.5,0,4.9,0C4.5,0,4.1,0.3,4,0.6C3.8,0.3,3.4,0,3,0S2.2,0.3,2,0.6 C1.9,0.3,1.5,0,1.1,0C0.5,0,0,0.5,0,1.1c0,0.4,0.3,0.8,0.6,1C0.3,2.2,0,2.6,0,3s0.3,0.8,0.6,1C0.3,4.1,0,4.5,0,4.9 C0,5.5,0.5,6,1.1,6c0.4,0,0.8-0.3,1-0.6C2.2,5.7,2.6,6,3,6s0.8-0.3,1-0.6C4.1,5.7,4.5,6,4.9,6C5.5,6,6,5.5,6,4.9 c0-0.4-0.3-0.8-0.6-1C5.7,3.8,6,3.4,6,3z"/>',
    rotate: false,
    marker: true,
  },
  flower: {
    path: '<path d="M4.3,6H1.7C0.8,6,0,5.2,0,4.3V0h4.3C5.2,0,6,0.8,6,1.7v2.6C6,5.2,5.2,6,4.3,6z"/>',
    rotate: true,
    marker: true,
  },
  elastic: {
    path: '<path d="M6,6L6,6C4.1,5.4,1.9,5.4,0,6l0,0l0,0c0.6-1.9,0.6-4.1,0-6l0,0l0,0c1.9,0.6,4.1,0.6,6,0l0,0l0,0C5.4,1.9,5.4,4.1,6,6L6,6z"/>',
    rotate: false,
    marker: true,
  },
  diagonal: {
    path: '<polygon points="6,6 3,6 0,3 0,0 3,0 6,3 "/>',
    rotate: true,
    marker: true,
  },
  ropes: {
    path: '<path d="M5.1,1.9H0.9C0.4,1.9,0,1.5,0,1v0c0-0.5,0.4-0.9,0.9-0.9h4.2C5.6,0.1,6,0.5,6,1v0C6,1.5,5.6,1.9,5.1,1.9z"/><path d="M5.1,3.9H0.9C0.4,3.9,0,3.5,0,3v0c0-0.5,0.4-0.9,0.9-0.9h4.2C5.6,2.1,6,2.5,6,3v0C6,3.5,5.6,3.9,5.1,3.9z"/><path d="M5.1,5.9H0.9C0.4,5.9,0,5.5,0,5v0c0-0.5,0.4-0.9,0.9-0.9h4.2C5.6,4.1,6,4.5,6,5v0C6,5.5,5.6,5.9,5.1,5.9z"/>',
    rotate: false,
    marker: true,
  },
  "ropes-vert": {
    path: '<path d="M4.1,5.1V0.9C4.1,0.4,4.5,0,5,0h0c0.5,0,0.9,0.4,0.9,0.9v4.2C5.9,5.6,5.5,6,5,6h0C4.5,6,4.1,5.6,4.1,5.1z"/><path d="M2.1,5.1V0.9C2.1,0.4,2.5,0,3,0h0c0.5,0,0.9,0.4,0.9,0.9v4.2C3.9,5.6,3.5,6,3,6h0C2.5,6,2.1,5.6,2.1,5.1z"/><path d="M0.1,5.1V0.9C0.1,0.4,0.5,0,1,0h0c0.5,0,0.9,0.4,0.9,0.9v4.2C1.9,5.6,1.5,6,1,6h0C0.5,6,0.1,5.6,0.1,5.1z"/>',
    rotate: false,
    marker: true,
  },
  bruised: {
    path: '<path d="M1.5,6C1.2,5.3,0.7,4.8,0,4.5v-3C0,0.7,0.7,0,1.5,0h3C4.8,0.7,5.3,1.2,6,1.5v3C6,5.3,5.3,6,4.5,6H1.5z"/>',
    rotate: true,
    marker: true,
  },
};

export const FRAMES = {
  [FORM_NONE]: {
    'path': '<polygon points="18.7,6.6 12,13.3 5.3,6.6 4.6,7.3 11.3,14 4.6,20.7 5.3,21.4 12,14.7 18.7,21.4 19.4,20.7 12.7,14 19.4,7.3 "/>',
  },
  'bottom': {
    'path': '<path d="M22.7,0H1.3C0.6,0,0,0.6,0,1.3v25.3C0,27.4,0.6,28,1.3,28h21.3c0.7,0,1.3-0.6,1.3-1.3V1.3C24,0.6,23.4,0,22.7,0 z M23,22c0,0.6-0.5,1-1,1H2c-0.6,0-1-0.5-1-1V2c0-0.6,0.5-1,1-1h20c0.6,0,1,0.5,1,1V22z"/>',
    'label_pos': 'bottom',
    'label_size': 3,
    'label_offset': 0,
    'frame_border': 1,
  },
  'top': {
    'path': '<path d="M1.3,28L22.6,28c0.7,0,1.3-0.6,1.3-1.3L24,1.4c0-0.7-0.6-1.3-1.3-1.3L1.4,0C0.7,0,0.1,0.6,0,1.3L0,26.6 C-0.1,27.4,0.5,28,1.3,28z M1,6c0-0.6,0.5-1,1-1L22,5c0.6,0,1,0.5,1,1L23,26c0,0.6-0.5,1-1,1L2,27c-0.6,0-1-0.5-1-1L1,6z"/>',
    'label_pos': 'top',
    'label_size': 3,
    'label_offset': 0,
    'frame_border': 1,
  },
  'balloon-bottom': {
    'path': '<path d="M1.3,24l21.3,0c0.7,0,1.3-0.6,1.3-1.3l0-21.3C24,0.6,23.4,0,22.7,0L1.3,0C0.6,0,0,0.6,0,1.3l0,21.3 C0,23.4,0.6,24,1.3,24z M1,2c0-0.6,0.5-1,1-1l20,0c0.6,0,1,0.5,1,1v20c0,0.6-0.5,1-1,1L2,23c-0.6,0-1-0.5-1-1V2z"/><path d="M1,30h22c0.5,0,1-0.4,1-1v-3c0-0.5-0.4-1-1-1H13l-1-1l-1,1H1c-0.5,0-1,0.4-1,1v3C0,29.6,0.4,30,1,30z"/>',
    'label_pos': 'bottom',
    'label_size': 3,
    'label_offset': 2,
    'frame_border': 1,
  },
  'balloon-top': {
    'path': '<path d="M22.7,6L1.3,6C0.6,6,0,6.6,0,7.3l0,21.3C0,29.4,0.6,30,1.3,30l21.3,0c0.7,0,1.3-0.6,1.3-1.3l0-21.3 C24,6.6,23.4,6,22.7,6z M23,28c0,0.6-0.5,1-1,1L2,29c-0.6,0-1-0.5-1-1V8c0-0.6,0.5-1,1-1l20,0c0.6,0,1,0.5,1,1V28z"/><path d="M23,0H1C0.4,0,0,0.4,0,1v3c0,0.5,0.4,1,1,1h10l1,1l1-1h10c0.5,0,1-0.4,1-1V1C24,0.4,23.6,0,23,0z"/>',
    'label_pos': 'top',
    'label_size': 3,
    'label_offset': 2,
    'frame_border': 1,
  },
  'ribbon-bottom': {
    'path': '<path d="M24,21h-1.7V1.7H1.7V21H0l1,2l-1,2h1v2h22v-2h1l-1-2L24,21z M2,2h20v19v1H2v-1V2z"/>',
    'label_pos': 'bottom',
    'label_size': 3,
    'label_offset': -1,
    'frame_border': 2,
  },
  'ribbon-top': {
    'path': '<path d="M0,6h1.7v19.3h20.7V6H24l-1-2l1-2h-1V0H1v2H0l1,2L0,6z M22,25H2V6V5h20v1V25z"/>',
    'label_pos': 'top',
    'label_size': 3,
    'label_offset': -1,
    'frame_border': 2,
  },
  'phone': {
    'path': '<path d="M17.6,0H6.4c-1,0-1.8,0.8-1.8,1.8v20.4c0,1,0.8,1.8,1.8,1.8h11.1c1,0,1.8-0.8,1.8-1.8V1.8C19.4,0.8,18.6,0,17.6,0z M11.2,2.3h2.7c0.1,0,0.2,0.1,0.2,0.2S14,2.7,13.9,2.7h-2.7c-0.1,0-0.2-0.1-0.2-0.2S11.1,2.3,11.2,2.3z M10.1,2.3 c0.1,0,0.2,0.1,0.2,0.2s-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2S10,2.3,10.1,2.3z M19,19H5V5h14V19z"/>',
    'label_pos': 'bottom',
    'label_size': 4,
    'label_offset': -4.5,
    'frame_border': 5,
    hidden: true
  },
  'cine': {
    'path': `<path d="M4.5,4.5L4.5,4.5L4.5,4.5l0,17.2c0,0.3,0.3,0.6,0.6,0.6h13.8c0.3,0,0.6-0.3,0.6-0.6V4.5H4.5z M19,18.6 c0,0.2-0.2,0.4-0.4,0.4H5.4C5.2,19,5,18.8,5,18.6V5.4C5,5.2,5.2,5,5.4,5h13.1C18.8,5,19,5.2,19,5.4V18.6z"/><path d="M19.1,0.1L4.2,1.7l0.3,2.8l14.9-1.6L19.1,0.1z M6.8,3.8L4.9,4l1.7-2.1l1.9-0.2L6.8,3.8z M10.5,3.4L8.6,3.6l1.7-2.1l1.9-0.2 L10.5,3.4z M14.2,3l-1.9,0.2L14,1.1l1.9-0.2L14.2,3z M18,2.6l-1.9,0.2l1.7-2.1l0.9-0.1l0.1,0.9L18,2.6z"/>`,
    'label_pos': 'bottom',
    'label_size': 2.5,
    'label_offset': -4.6,
    'frame_border': 5,
  },
};

export const LOGOS = {
  "00-none": {
    src: `<svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path> </svg>`,
    value: FORM_NONE
  },
  "01-link.png": {
    src: "/images/qrcode-create/generate/watermarks/01-link.png",
    value: "images/watermarks/01-link.png",
  },
  "02-email-b.png": {
    src: "/images/qrcode-create/generate/watermarks/02-email-b.png",
    value: "images/qrtermarks/02-email-b.png",
  },
  "02-email.png": {
    src: "/images/qrcode-create/generate/watermarks/02-email.png",
    value: "images/watermarks/02-email.png",
  },
  "03-location-b.png": {
    src: "/images/qrcode-create/generate/watermarks/03-location-b.png",
    value: "images/qrcodmarks/03-location-b.png",
  },
  "03-location.png": {
    src: "/images/qrcode-create/generate/watermarks/03-location.png",
    value: "images/qrcermarks/03-location.png",
  },
  "04-whatsapp.png": {
    src: "/images/qrcode-create/generate/watermarks/04-whatsapp.png",
    value: "images/qrcermarks/04-whatsapp.png",
  },
  "05-skype.png": {
    src: "/images/qrcode-create/generate/watermarks/05-skype.png",
    value: "images/watermarks/05-skype.png",
  },
  "06-zoom-b.png": {
    src: "/images/qrcode-create/generate/watermarks/06-zoom-b.png",
    value: "images/qatermarks/06-zoom-b.png",
  },
  "06-zoom.png": {
    src: "/images/qrcode-create/generate/watermarks/06-zoom.png",
    value: "images/watermarks/06-zoom.png",
  },
  "07-wifi-b.png": {
    src: "/images/qrcode-create/generate/watermarks/07-wifi-b.png",
    value: "images/qatermarks/07-wifi-b.png",
  },
  "07-wifi.png": {
    src: "/images/qrcode-create/generate/watermarks/07-wifi.png",
    value: "images/watermarks/07-wifi.png",
  },
  "08-vcard-b.png": {
    src: "/images/qrcode-create/generate/watermarks/08-vcard-b.png",
    value: "images/qrtermarks/08-vcard-b.png",
  },
  "08-vcard.png": {
    src: "/images/qrcode-create/generate/watermarks/08-vcard.png",
    value: "images/watermarks/08-vcard.png",
  },
  "09-calendar-b.png": {
    src: "/images/qrcode-create/generate/watermarks/09-calendar-b.png",
    value: "images/qrcodmarks/09-calendar-b.png",
  },
  "09-calendar.png": {
    src: "/images/qrcode-create/generate/watermarks/09-calendar.png",
    value: "images/qrcermarks/09-calendar.png",
  },
  "10-paypal.png": {
    src: "/images/qrcode-create/generate/watermarks/10-paypal.png",
    value: "images/qatermarks/10-paypal.png",
  },
  "11-btc-b.png": {
    src: "/images/qrcode-create/generate/watermarks/11-btc-b.png",
    value: "images/watermarks/11-btc-b.png",
  },
  "11-btc.png": {
    src: "/images/qrcode-create/generate/watermarks/11-btc.png",
    value: "imagee/watermarks/11-btc.png",
  },
};

export const FRONT_COLORS = {
  single: { name: "Màu đơn sắc", value: "single" },
  linear: { name: "Màu Linear Gradient", value: "linear" },
  gradient: { name: "Màu Radial Gradient", value: "gradient" },
};

export const SIZES = {
  200: { value: 8 },
  300: { value: 12 },
  400: { value: 16 },
  500: { value: 20 },
  600: { value: 24 },
  700: { value: 28 },
  800: { value: 32 },
};

export const PRECISIONS = {
  l: { value: "L", name: "L - Thấp" },
  m: { value: "M", name: "M - Trung bình" },
  q: { value: "Q", name: "Q - Cao" },
  h: { value: "H", name: "H - Tốt nhất" },
};

export const FONTS = {
  "AbrilFatface": { value: "AbrilFatface.svg" },
  "CormorantGaramond": { value: "CormorantGaramond.svg" },
  "FredokaOne": { value: "FredokaOne.svg" },
  "Galindo": { value: "Galindo.svg" },
  "OleoScript": { value: "OleoScript.svg" },
  "PlayfairDisplay": { value: "PlayfairDisplay.svg" },
  "Shrikhand": { value: "Shrikhand.svg" },
  "ZCOOLKuaiLe-Regular": { value: "ZCOOLKuaile-Regular.svg" },
};

export const SKYPE_TYPE = {
  call: { value: "call", name: "Thoại" },
  chat: { value: "chat", name: "Chat" },
};

export const COUNTRY_CODES = {
  1: {
    code: null,
    name: "--"
  },
  2: {
    code: 7840,
    name: "Abkhazia (+7 840)"
  },
  3: {
    code: 7940,
    name: "Abkhazia (+7 940)"
  },
  4: {
    code: 93,
    name: "Afghanistan (+93)"
  },
  5: {
    code: 355,
    name: "Albania (+355)"
  },
  6: {
    code: 213,
    name: "Algeria (+213)"
  },
  7: {
    code: 1684,
    name: "American Samoa (+1 684)"
  },
  8: {
    code: 376,
    name: "Andorra (+376)"
  },
  9: {
    code: 244,
    name: "Angola (+244)"
  },
  10: {
    code: 1264,
    name: "Anguilla (+1 264)"
  },
  11: {
    code: 1268,
    name: "Antigua and Barbuda (+1 268)"
  },
  12: {
    code: 54,
    name: "Argentina (+54)"
  },
  13: {
    code: 374,
    name: "Armenia (+374)"
  },
  14: {
    code: 297,
    name: "Aruba (+297)"
  },
  15: {
    code: 247,
    name: "Ascension (+247)"
  },
  16: {
    code: 61,
    name: "Australia (+61)"
  },
  17: {
    code: 672,
    name: "Australian External Territories (+672)"
  },
  18: {
    code: 43,
    name: "Austria (+43)"
  },
  19: {
    code: 994,
    name: "Azerbaijan (+994)"
  },
  20: {
    code: 1242,
    name: "Bahamas (+1 242)"
  },
  21: {
    code: 973,
    name: "Bahrain (+973)"
  },
  22: {
    code: 880,
    name: "Bangladesh (+880)"
  },
  23: {
    code: 1246,
    name: "Barbados (+1 246)"
  },
  24: {
    code: 1268,
    name: "Barbuda (+1 268)"
  },
  25: {
    code: 375,
    name: "Belarus (+375)"
  },
  26: {
    code: 32,
    name: "Belgium (+32)"
  },
  27: {
    code: 501,
    name: "Belize (+501)"
  },
  28: {
    code: 229,
    name: "Benin (+229)"
  },
  29: {
    code: 1441,
    name: "Bermuda (+1 441)"
  },
  30: {
    code: 975,
    name: "Bhutan (+975)"
  },
  31: {
    code: 591,
    name: "Bolivia (+591)"
  },
  32: {
    code: 387,
    name: "Bosnia and Herzegovina (+387)"
  },
  33: {
    code: 267,
    name: "Botswana (+267)"
  },
  34: {
    code: 55,
    name: "Brazil (+55)"
  },
  35: {
    code: 246,
    name: "British Indian Ocean Territory (+246)"
  },
  36: {
    code: 1284,
    name: "British Virgin Islands (+1 284)"
  },
  37: {
    code: 673,
    name: "Brunei (+673)"
  },
  38: {
    code: 359,
    name: "Bulgaria (+359)"
  },
  39: {
    code: 226,
    name: "Burkina Faso (+226)"
  },
  40: {
    code: 257,
    name: "Burundi (+257)"
  },
  41: {
    code: 855,
    name: "Cambodia (+855)"
  },
  42: {
    code: 237,
    name: "Cameroon (+237)"
  },
  43: {
    code: 1,
    name: "Canada (+1)"
  },
  44: {
    code: 238,
    name: "Cape Verde (+238)"
  },
  45: {
    code: 345,
    name: "Cayman Islands (+345)"
  },
  46: {
    code: 236,
    name: "Central African Republic (+236)"
  },
  47: {
    code: 235,
    name: "Chad (+235)"
  },
  48: {
    code: 56,
    name: "Chile (+56)"
  },
  49: {
    code: 86,
    name: "China (+86)"
  },
  50: {
    code: 61,
    name: "Christmas Island (+61)"
  },
  51: {
    code: 61,
    name: "Cocos-Keeling Islands (+61)"
  },
  52: {
    code: 57,
    name: "Colombia (+57)"
  },
  53: {
    code: 269,
    name: "Comoros (+269)"
  },
  54: {
    code: 242,
    name: "Congo (+242)"
  },
  55: {
    code: 243,
    name: "Congo, Dem. Rep. of (Zaire) (+243)"
  },
  56: {
    code: 682,
    name: "Cook Islands (+682)"
  },
  57: {
    code: 506,
    name: "Costa Rica (+506)"
  },
  58: {
    code: 225,
    name: "Ivory Coast (+225)"
  },
  59: {
    code: 385,
    name: "Croatia (+385)"
  },
  60: {
    code: 53,
    name: "Cuba (+53)"
  },
  61: {
    code: 599,
    name: "Curacao (+599)"
  },
  62: {
    code: 537,
    name: "Cyprus (+537)"
  },
  63: {
    code: 420,
    name: "Czech Republic (+420)"
  },
  64: {
    code: 45,
    name: "Denmark (+45)"
  },
  65: {
    code: 246,
    name: "Diego Garcia (+246)"
  },
  66: {
    code: 253,
    name: "Djibouti (+253)"
  },
  67: {
    code: 1767,
    name: "Dominica (+1 767)"
  },
  68: {
    code: 1809,
    name: "Dominican Republic (+1 809)"
  },
  69: {
    code: 1829,
    name: "Dominican Republic (+1 829)"
  },
  70: {
    code: 1849,
    name: "Dominican Republic (+1 849)"
  },
  71: {
    code: 670,
    name: "East Timor (+670)"
  },
  72: {
    code: 56,
    name: "Easter Island (+56)"
  },
  73: {
    code: 593,
    name: "Ecuador (+593)"
  },
  74: {
    code: 20,
    name: "Egypt (+20)"
  },
  75: {
    code: 503,
    name: "El Salvador (+503)"
  },
  76: {
    code: 240,
    name: "Equatorial Guinea (+240)"
  },
  77: {
    code: 291,
    name: "Eritrea (+291)"
  },
  78: {
    code: 372,
    name: "Estonia (+372)"
  },
  79: {
    code: 251,
    name: "Ethiopia (+251)"
  },
  80: {
    code: 500,
    name: "Falkland Islands (+500)"
  },
  81: {
    code: 298,
    name: "Faroe Islands (+298)"
  },
  82: {
    code: 679,
    name: "Fiji (+679)"
  },
  83: {
    code: 358,
    name: "Finland (+358)"
  },
  84: {
    code: 33,
    name: "France (+33)"
  },
  85: {
    code: 596,
    name: "French Antilles (+596)"
  },
  86: {
    code: 594,
    name: "French Guiana (+594)"
  },
  87: {
    code: 689,
    name: "French Polynesia (+689)"
  },
  88: {
    code: 241,
    name: "Gabon (+241)"
  },
  89: {
    code: 220,
    name: "Gambia (+220)"
  },
  90: {
    code: 995,
    name: "Georgia (+995)"
  },
  91: {
    code: 49,
    name: "Germany (+49)"
  },
  92: {
    code: 233,
    name: "Ghana (+233)"
  },
  93: {
    code: 350,
    name: "Gibraltar (+350)"
  },
  94: {
    code: 30,
    name: "Greece (+30)"
  },
  95: {
    code: 299,
    name: "Greenland (+299)"
  },
  96: {
    code: 1473,
    name: "Grenada (+1 473)"
  },
  97: {
    code: 590,
    name: "Guadeloupe (+590)"
  },
  98: {
    code: 1671,
    name: "Guam (+1 671)"
  },
  99: {
    code: 502,
    name: "Guatemala (+502)"
  },
  100: {
    code: 224,
    name: "Guinea (+224)"
  },
  101: {
    code: 245,
    name: "Guinea-Bissau (+245)"
  },
  102: {
    code: 595,
    name: "Guyana (+595)"
  },
  103: {
    code: 509,
    name: "Haiti (+509)"
  },
  104: {
    code: 504,
    name: "Honduras (+504)"
  },
  105: {
    code: 852,
    name: "Hong Kong SAR China (+852)"
  },
  106: {
    code: 36,
    name: "Hungary (+36)"
  },
  107: {
    code: 354,
    name: "Iceland (+354)"
  },
  108: {
    code: 91,
    name: "India (+91)"
  },
  109: {
    code: 62,
    name: "Indonesia (+62)"
  },
  110: {
    code: 98,
    name: "Iran (+98)"
  },
  111: {
    code: 964,
    name: "Iraq (+964)"
  },
  112: {
    code: 353,
    name: "Ireland (+353)"
  },
  113: {
    code: 972,
    name: "Israel (+972)"
  },
  114: {
    code: 39,
    name: "Italy (+39)"
  },
  115: {
    code: 1876,
    name: "Jamaica (+1 876)"
  },
  116: {
    code: 81,
    name: "Japan (+81)"
  },
  117: {
    code: 962,
    name: "Jordan (+962)"
  },
  118: {
    code: 77,
    name: "Kazakhstan (+7 7)"
  },
  119: {
    code: 254,
    name: "Kenya (+254)"
  },
  120: {
    code: 686,
    name: "Kiribati (+686)"
  },
  121: {
    code: 850,
    name: "North Korea (+850)"
  },
  122: {
    code: 82,
    name: "South Korea (+82)"
  },
  123: {
    code: 965,
    name: "Kuwait (+965)"
  },
  124: {
    code: 996,
    name: "Kyrgyzstan (+996)"
  },
  125: {
    code: 856,
    name: "Laos (+856)"
  },
  126: {
    code: 371,
    name: "Latvia (+371)"
  },
  127: {
    code: 961,
    name: "Lebanon (+961)"
  },
  128: {
    code: 266,
    name: "Lesotho (+266)"
  },
  129: {
    code: 231,
    name: "Liberia (+231)"
  },
  130: {
    code: 218,
    name: "Libya (+218)"
  },
  131: {
    code: 423,
    name: "Liechtenstein (+423)"
  },
  132: {
    code: 370,
    name: "Lithuania (+370)"
  },
  133: {
    code: 352,
    name: "Luxembourg (+352)"
  },
  134: {
    code: 853,
    name: "Macau SAR China (+853)"
  },
  135: {
    code: 389,
    name: "Macedonia (+389)"
  },
  136: {
    code: 261,
    name: "Madagascar (+261)"
  },
  137: {
    code: 265,
    name: "Malawi (+265)"
  },
  138: {
    code: 60,
    name: "Malaysia (+60)"
  },
  139: {
    code: 960,
    name: "Maldives (+960)"
  },
  140: {
    code: 223,
    name: "Mali (+223)"
  },
  141: {
    code: 356,
    name: "Malta (+356)"
  },
  142: {
    code: 692,
    name: "Marshall Islands (+692)"
  },
  143: {
    code: 596,
    name: "Martinique (+596)"
  },
  144: {
    code: 222,
    name: "Mauritania (+222)"
  },
  145: {
    code: 230,
    name: "Mauritius (+230)"
  },
  146: {
    code: 262,
    name: "Mayotte (+262)"
  },
  147: {
    code: 52,
    name: "Mexico (+52)"
  },
  148: {
    code: 691,
    name: "Micronesia (+691)"
  },
  149: {
    code: 1808,
    name: "Midway Island (+1 808)"
  },
  150: {
    code: 691,
    name: "Micronesia (+691)"
  },
  151: {
    code: 373,
    name: "Moldova (+373)"
  },
  152: {
    code: 377,
    name: "Monaco (+377)"
  },
  153: {
    code: 976,
    name: "Mongolia (+976)"
  },
  154: {
    code: 382,
    name: "Montenegro (+382)"
  },
  155: {
    code: 1664,
    name: "Montserrat (+1664)"
  },
  156: {
    code: 212,
    name: "Morocco (+212)"
  },
  157: {
    code: 95,
    name: "Myanmar (+95)"
  },
  158: {
    code: 264,
    name: "Namibia (+264)"
  },
  159: {
    code: 674,
    name: "Nauru (+674)"
  },
  160: {
    code: 977,
    name: "Nepal (+977)"
  },
  161: {
    code: 31,
    name: "Netherlands (+31)"
  },
  162: {
    code: 599,
    name: "Netherlands Antilles (+599)"
  },
  163: {
    code: 1869,
    name: "Nevis (+1 869)"
  },
  164: {
    code: 687,
    name: "New Caledonia (+687)"
  },
  165: {
    code: 64,
    name: "New Zealand (64)"
  },
  166: {
    code: 505,
    name: "Nicaragua (+505)"
  },
  167: {
    code: 227,
    name: "Niger (+227)"
  },
  168: {
    code: 234,
    name: "Nigeria (+234)"
  },
  169: {
    code: 683,
    name: "Niue (+683)"
  },
  170: {
    code: 672,
    name: "Norfolk Island (+672)"
  },
  171: {
    code: 1670,
    name: "Northern Mariana Islands (+1 670)"
  },
  172: {
    code: 47,
    name: "Norway (+47)"
  },
  173: {
    code: 968,
    name: "Oman (+968)"
  },
  174: {
    code: 92,
    name: "Pakistan (+92)"
  },
  175: {
    code: 680,
    name: "Palau (+680)"
  },
  176: {
    code: 970,
    name: "Palestinian Territory (+970)"
  },
  177: {
    code: 507,
    name: "Panama (+507)"
  },
  178: {
    code: 675,
    name: "Papua New Guinea (+675)"
  },
  179: {
    code: 595,
    name: "Paraguay (+595)"
  },
  180: {
    code: 51,
    name: "Peru (+51)"
  },
  181: {
    code: 63,
    name: "Philippines (+63)"
  },
  182: {
    code: 48,
    name: "Poland (+48)"
  },
  183: {
    code: 351,
    name: "Portugal (+351)"
  },
  184: {
    code: 1787,
    name: "Puerto Rico (+1 787)"
  },
  185: {
    code: 1939,
    name: "Puerto Rico (+1 939)"
  },
  186: {
    code: 974,
    name: "Qatar (+974)"
  },
  187: {
    code: 262,
    name: "Reunion (+262)"
  },
  188: {
    code: 40,
    name: "Romania (+40)"
  },
  189: {
    code: 7,
    name: "Russia (+7)"
  },
  190: {
    code: 250,
    name: "Rwanda (+250)"
  },
  191: {
    code: 685,
    name: "Samoa (+685)"
  },
  192: {
    code: 378,
    name: "San Marino (+378)"
  },
  193: {
    code: 966,
    name: "Saudi Arabia (+966)"
  },
  194: {
    code: 221,
    name: "Senegal (+221)"
  },
  195: {
    code: 381,
    name: "Serbia (+381)"
  },
  196: {
    code: 248,
    name: "Seychelles (+248)"
  },
  197: {
    code: 232,
    name: "Sierra Leone (+232)"
  },
  198: {
    code: 65,
    name: "Singapore (+65)"
  },
  199: {
    code: 421,
    name: "Slovakia (+421)"
  },
  200: {
    code: 386,
    name: "Slovenia (+386)"
  },
  201: {
    code: 677,
    name: "Solomon Islands (+677)"
  },
  202: {
    code: 27,
    name: "South Africa (+27)"
  },
  203: {
    code: 500,
    name: "South Georgia and the South Sandwich Islands (+500)"
  },
  204: {
    code: 34,
    name: "Spain (+34)"
  },
  205: {
    code: 94,
    name: "Sri Lanka (+94)"
  },
  206: {
    code: 249,
    name: "Sudan (+249)"
  },
  207: {
    code: 597,
    name: "Suriname (+597)"
  },
  208: {
    code: 268,
    name: "Swaziland (+268)"
  },
  209: {
    code: 46,
    name: "Sweden (+46)"
  },
  210: {
    code: 41,
    name: "Switzerland (+41)"
  },
  211: {
    code: 963,
    name: "Syria (+963)"
  },
  212: {
    code: 886,
    name: "Taiwan (+886)"
  },
  213: {
    code: 992,
    name: "Tajikistan (+992)"
  },
  214: {
    code: 255,
    name: "Tanzania (+255)"
  },
  215: {
    code: 66,
    name: "Thailand (+66)"
  },
  216: {
    code: 670,
    name: "Timor Leste (+670)"
  },
  217: {
    code: 228,
    name: "Togo (+228)"
  },
  218: {
    code: 690,
    name: "Tokelau (+690)"
  },
  219: {
    code: 676,
    name: "Tonga (+676)"
  },
  220: {
    code: 1868,
    name: "Trinidad and Tobago (+1 868)"
  },
  221: {
    code: 216,
    name: "Tunisia (+216)"
  },
  222: {
    code: 90,
    name: "Turkey (+90)"
  },
  223: {
    code: 993,
    name: "Turkmenistan (+993)"
  },
  224: {
    code: 1649,
    name: "Turks and Caicos Islands (+1 649)"
  },
  225: {
    code: 688,
    name: "Tuvalu (+688)"
  },
  226: {
    code: 256,
    name: "Uganda (+256)"
  },
  227: {
    code: 380,
    name: "Ukraine (+380)"
  },
  228: {
    code: 971,
    name: "United Arab Emirates (+971)"
  },
  229: {
    code: 44,
    name: "United Kingdom (+44)"
  },
  230: {
    code: 1,
    name: "United States (+1)"
  },
  231: {
    code: 598,
    name: "Uruguay (+598)"
  },
  232: {
    code: 1340,
    name: "U.S. Virgin Islands (+1 340)"
  },
  233: {
    code: 998,
    name: "Uzbekistan (+998)"
  },
  234: {
    code: 678,
    name: "Vanuatu (+678)"
  },
  235: {
    code: 58,
    name: "Venezuela (+58)"
  },
  236: {
    code: 84,
    name: "Vietnam (+84)"
  },
  237: {
    code: 1808,
    name: "Wake Island (+1 808)"
  },
  238: {
    code: 681,
    name: "Wallis and Futuna (+681)"
  },
  239: {
    code: 967,
    name: "Yemen (+967)"
  },
  240: {
    code: 260,
    name: "Zambia (+260)"
  },
  241: {
    code: 255,
    name: "Zanzibar (+255)"
  },
  242: {
    code: 263,
    name: "Zimbabwe (+263)"
  },
};

export const COUNTRY_CODES_DEFAULT = COUNTRY_CODES[1].code;

export const WIFI_NETWORK_TYPE = {
  WEP: { value: "WEP", name: "WEP" },
  WAP: { value: "WAP", name: "WPA/WPA2" },
  NONE: { value: "", name: "Không mã hóa" },
};

export const VCARD_VERSION = {
  "2.1": { value: "2.1", name: "2.1" },
  "3.0": { value: "3.0", name: "3.0" },
};

export const EVENT_REMIDER_BEFORE_EVENT =
{
  "": { value: null, name: "--" },
  "PT0M": { value: "PT0M", name: "Khi sự kiện bắt đầu" },
  "-PT5M": { value: "-PT5M", name: "5 phút" },
  "-PT10M": { value: "-PT10M", name: "10 phút" },
  "-PT15M": { value: "-PT15M", name: "15 phút" },
  "-PT30M": { value: "-PT30M", name: "30 phút" },
  "-PT1H": { value: "-PT1H", name: "1 giờ" },
  "-PT2H": { value: "-PT2H", name: "2 giờ" },
  "-PT3H": { value: "-PT3H", name: "3 giờ" },
  "-PT4H": { value: "-PT4H", name: "4 giờ" },
  "-PT5H": { value: "-PT5H", name: "5 giờ" },
  "-PT6H": { value: "-PT6H", name: "6 giờ" },
  "-PT12H": { value: "-PT12H", name: "12 giờ" },
  "-PT24H": { value: "-PT24H", name: "24 giờ" },
  "-PT48H": { value: "-PT48H", name: "48 giờ" },
  "-PT168H": { value: "-PT168H", name: "1 tuần" }
};

export const PAYPAL_PAYMENT_TYPES = {
  _xclick: { value: "_xclick", name: "Mua ngay" },
  _cart: { value: "_cart", name: "Thêm vào giỏ hàng" },
  _donations: { value: "_donations", name: "Quyên góp" }
};

export const PAYPAL_CURRENCY = {
  USD: { value: "USD", name: "United States dollar" },
  EUR: { value: "EUR", name: "Euro" },
  AUD: { value: "AUD", name: "Australian dollar" },
  BRL: { value: "BRL", name: "Brazilian real" },
  CAD: { value: "CAD", name: "Canadian dollar" },
  CNY: { value: "CNY", name: "Chinese Renmenbi" },
  CZK: { value: "CZK", name: "Czech koruna" },
  DKK: { value: "DKK", name: "Danish krone" },
  HKD: { value: "HKD", name: "Hong Kong dollar" },
  HUF: { value: "HUF", name: "Hungarian forint" },
  INR: { value: "INR", name: "Indian rupee" },
  ILS: { value: "ILS", name: "Israeli new shekel" },
  JPY: { value: "JPY", name: "Japanese yen" },
  MYR: { value: "MYR", name: "Malaysian ringgit" },
  MXN: { value: "MXN", name: "Mexican peso" },
  TWD: { value: "TWD", name: "New Taiwan dollar" },
  NZD: { value: "NZD", name: "New Zealand dollar" },
  NOK: { value: "NOK", name: "Norwegian krone" },
  PHP: { value: "PHP", name: "Philippine peso" },
  PLN: { value: "PLN", name: "Polish złoty" },
  GBP: { value: "GBP", name: "Pound sterling" },
  RUB: { value: "RUB", name: "Russian ruble" },
  SGD: { value: "SGD", name: "Singapore dollar" },
  SEK: { value: "SEK", name: "Swedish krona" },
  CHF: { value: "CHF", name: "Swiss franc" },
  THB: { value: "THB", name: "Thai baht" }
};

const RULE_MESSAGE_REQUIRED = "Không được để trống";

export const SECTIONS = {
  link: {
    name: "Link",
    value: "#link",
    fields: {
      link: {
        value: "link", label: "URL", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }],
      },
    }
  },
  text: {
    name: "Văn bản",
    value: "#text",
    fields: {
      data: {
        value: "data", label: "Nội dung", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
    },
  },
  email: {
    name: "Mail",
    value: "#email",
    fields: {
      mailto: {
        value: "mailto", label: "Gửi đến", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      cc: { value: "cc", label: "Cc", default: "" },
      bcc: { value: "bcc", label: "Bcc", default: "" },
      subject: { value: "subject", label: "Tiêu đề", default: "" },
      body: { value: "body", label: "Nội dung", default: "" },
    },
  },
  location: {
    name: "Vị trí",
    value: "#location",
    fields: {
      lat: {
        value: "lat", label: "Vĩ độ", default: null,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      lng: {
        value: "lng", label: "Kinh độ", default: null,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
    },
  },
  tel: {
    name: "Điện thoại",
    value: "#tel",
    fields: {
      countrycodetel: { value: "countrycodetel", label: "Mã vùng", default: COUNTRY_CODES_DEFAULT },
      tel: {
        value: "tel", label: "Số điện thoại", default: null,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
    },
  },
  sms: {
    name: "SMS",
    value: "#sms",
    fields: {
      countrycodesms: { value: "countrycodesms", label: "Mã vùng", default: COUNTRY_CODES_DEFAULT },
      sms: {
        value: "sms", label: "Số điện thoại", default: null,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      bodysms: { value: "bodysms", label: "Nội dung", default: "" },
    },
  },
  whatsapp: {
    name: "Whatsapp",
    value: "#whatsapp",
    fields: {
      wapp_countrycode: { value: "wapp_countrycode", label: "Mã vùng", default: COUNTRY_CODES_DEFAULT },
      wapp_number: {
        value: "wapp_number", label: "Số điện thoại", default: null,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      wapp_message: { value: "wapp_message", label: "Nội dung", default: "" },
    },
  },
  skype: {
    name: "Skype",
    value: "#skype",
    fields: {
      skypeType: {
        value: "skypeType", default: SKYPE_TYPE.call.value,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      skype: {
        value: "skype", label: "Tên tài khoản", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
    },
  },
  zoom: {
    name: "Zoom",
    value: "#zoom",
    fields: {
      zoom_id: {
        value: "zoom_id", label: "ID cuộc họp", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      zoom_pwd: {
        value: "zoom_pwd", label: "Mật khẩu", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
    },
  },
  wifi: {
    name: "Wifi",
    value: "#wifi",
    fields: {
      ssid: {
        value: "ssid", label: "Tên", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      networktype: {
        value: "networktype", label: "Chuẩn bảo mật", default: WIFI_NETWORK_TYPE.WEP.value,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      wifipass: { value: "wifipass", label: "Mật khẩu", default: "" },
      wifihidden: { value: "wifihidden", label: "Ẩn", default: "" },
    },
  },
  vcard: {
    name: "V-Card",
    value: "#vcard",
    fields: {
      vversion: {
        value: "vversion", label: "Version", default: VCARD_VERSION["2.1"].value,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      vnametitle: { value: "vnametitle", label: "Tiêu đề", default: "" },
      vname: {
        value: "vname", label: "Tên", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      vlast: { value: "vlast", label: "Họ", default: "" },
      countrycodevphone: { value: "countrycodevphone", label: "SĐT (nhà riêng)", default: COUNTRY_CODES_DEFAULT },
      vphone: { value: "vphone", label: "SĐT (nhà riêng)", default: "" },
      countrycodemobile: { value: "countrycodemobile", label: "SĐT (di động)", default: COUNTRY_CODES_DEFAULT },
      vmobile: { value: "vmobile", label: "SĐT (di động)", default: "" },
      vemail: { value: "vemail", label: "E-mail", default: "" },
      vurl: { value: "vurl", label: "Website (URL)", default: "" },
      vcompany: { value: "vcompany", label: "Công ty", default: "" },
      vtitle: { value: "vtitle", label: "Vị trí", default: "" },
      countrycodevoffice: { value: "countrycodevoffice", label: "SĐT (Văn phòng)", default: COUNTRY_CODES_DEFAULT },
      vofficephone: { value: "vofficephone", label: "SĐT (Văn phòng)", default: "" },
      countrycodevfax: { value: "countrycodevfax", label: "Fax", default: COUNTRY_CODES_DEFAULT },
      vfax: { value: "vfax", label: "Fax", default: "" },
      vaddress: { value: "vaddress", label: "Địa chỉ", default: "" },
      vcap: { value: "vcap", label: "Mã bưu điện", default: "" },
      vcity: { value: "vcity", label: "Tỉnh", default: "" },
      vstate: { value: "vstate", label: "Huyện", default: "" },
      vcountry: { value: "vcountry", label: "Quốc gia", default: "" },
    },
  },
  event: {
    name: "Sự kiện",
    value: "#event",
    fields: {
      eventtitle: {
        value: "eventtitle", label: "Tiêu đề", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      eventlocation: { value: "location", label: "Địa chỉ", default: "" },
      eventstarttime: {
        value: "eventstarttime", label: "Thời gian bắt đầu", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      eventendtime: { value: "eventendtime", label: "Thời gian kết thúc", default: "" },
      eventreminder: { value: "eventreminder", label: "Nhắc trước", default: EVENT_REMIDER_BEFORE_EVENT[""].value },
      eventlink: { value: "eventlink", label: "Link", default: "" },
      notes: { value: "notes", label: "Ghi chú", default: "" },
    },
  },
  paypal: {
    name: "Paypal",
    value: "#paypal",
    fields: {
      pp_type: {
        value: "pp_type", label: "Loại thanh toán", default: PAYPAL_PAYMENT_TYPES._xclick.value,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      pp_email: {
        value: "pp_email", label: "E-mail", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      pp_name: {
        value: "pp_name", label: "Tên mặt hàng", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      pp_id: { value: "pp_id", label: "Id mặt hàng", default: "" },
      pp_price: { value: "pp_price", label: "Giá", default: null },
      pp_currency: {
        value: "pp_currency", label: "Đơn vị tiền tệ", default: PAYPAL_CURRENCY.USD.value,
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      pp_shipping: { value: "pp_shipping", label: "Phí vận chuyển", default: null },
      pp_tax: { value: "pp_tax", label: "Thuế", default: null },
    },
  },
  bitcoin: {
    name: "Bitcoin",
    value: "#bitcoin",
    fields: {
      btc_account: {
        value: "btc_account", label: "Địa chỉ", default: "",
        rules: [{ required: true, message: RULE_MESSAGE_REQUIRED, trigger: [] }]
      },
      btc_amount: { value: "btc_amount", label: "Số lượng", default: "" },
      btc_label: { value: "btc_label", label: "Nhãn", default: "" },
      btc_message: { value: "btc_message", label: "Nội dung", default: "" },
    },
  },
};

export const TABS = {
  colors: {
    name: "Màu sắc",
    value: "color",
    fields: {
      // Colors - Background
      backcolor: { value: "backcolor", default: COLOR_WHITE },
      transparent: { value: "transparent", default: false, label: "Nền trong suốt" },
      transparent_code: { value: "transparent_code", default: false, label: "Background ảnh" },
      bg_image: { value: "bg_image", default: null }, // Background image base 64
      negative_qr: { value: "negative_qr", default: false, label: "Masked" },
      // Colors - Foreground
      frontcolor: { value: "frontcolor", default: COLOR_BLACK },
      gradient: { value: "gradient", default: false },
      gradient_color: { value: "gradient_color", default: COLOR_PURPLE },
      radial: { value: "radial", default: false },
    },
  },
  design: {
    name: "Thiết kế",
    value: "design",
    fields: {
      // Design - Pattern
      pattern: { value: "pattern", default: FORM_DEFAULT },
      // Design - Marker Border
      marker_out: { value: "marker_out", default: FORM_DEFAULT },
      // Design - Marker Center
      marker_in: { value: "marker_in", default: FORM_DEFAULT },
      // Design - Custom mark colors
      markers_color: { value: "markers_color", default: false },
      marker_out_color: { value: "marker_out_color", default: COLOR_BLACK },
      marker_in_color: { value: "marker_in_color", default: COLOR_BLACK },
      // Design markers colors
      marker_top_right_outline: { value: "marker_top_right_outline", default: COLOR_BLACK },
      marker_top_right_center: { value: "marker_top_right_center", default: COLOR_BLACK },
      marker_bottom_left_outline: { value: "marker_bottom_left_outline", default: COLOR_BLACK },
      marker_bottom_left_center: { value: "marker_bottom_left_center", default: COLOR_BLACK },
    },
  },
  logo: {
    name: "Logo",
    value: "logo",
    fields: {
      optionlogo: { value: "optionlogo", default: FORM_NONE },
      logo_size: { value: "logo_size", default: 100 },
      no_logo_bg: { value: "no_logo_bg", default: null },
    },
  },
  frame: {
    name: "Khung",
    value: "frame",
    fields: {
      outer_frame: { value: "outer_frame", label: "Khung ngoài", default: FORM_NONE },
      framelabel: { value: "framelabel", label: "Tiêu đề", default: "SCAN ME" },
      label_font: { value: "label_font", label: "Phông chữ", default: FONTS.AbrilFatface.value },
      "label-text-size": { value: "label-text-size", label: "Cỡ chữ", default: 100 },
      custom_frame_color: { value: "custom_frame_color", label: "Màu sắc", default: false },
      framecolor: { value: "framecolor", label: "Màu sắc", default: COLOR_BLACK },
    },
  },
  option: {
    name: "Tùy chọn",
    value: "option",
    fields: {
      size: { value: "size", label: "Độ lớn", default: SIZES[600].value },
      level: { value: "level", label: "Độ chính xác", default: PRECISIONS.q.value },
    },
  },
};

export const EXPORT_ACTIONS = {
  png: { value: "png" },
  svg: { value: "svg" },
  pdf: { value: "pdf" },
  print: { value: "print" },
};
